import React, { useEffect, useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import MicOffRoundedIcon from '@mui/icons-material/MicOffRounded';
import VoiceOverOffRoundedIcon from '@mui/icons-material/VoiceOverOffRounded';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded';
import ChatIcon from '@mui/icons-material/Chat';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import PersonIcon from '@mui/icons-material/Person';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsApplicationsRoundedIcon from '@mui/icons-material/SettingsApplicationsRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

import {
  AlertIDIcon,
  AlertInProgressImage,
  AlertOption1,
  AlertSiteIcon,
  AlertTypeIcon,
  BackArrowDevice,
  BackToLive,
  BranchIcon,
  CloseIcon,
  InfoBlue,
  InformationBlue,
  InformationWhite,
  LoadingAlert,
  MosaicExitFullscreen,
  MosaicFullscreen,
  MosaicHooterOff,
  MosaicHooterOn,
  MosaicNoStream,
  MosaicSnapshot,
  MosaicTwowayStart,
  MosaicTwowayStop,
  NoMoreAlert,
  Pause,
  Play,
  PlayBack,
  PlayBackWhite,
  PrePost,
  PtzDownArrow,
  PtzHomeIcon,
  PtzIcon,
  PtzLeftArrow,
  PtzRightArrow,
  PtzUpArrow,
  PtzZoomInIcon,
  PtzZoomOutIcon,
  QC,
  QCWhite,
  Rewind,
  Save,
  SiteIcon,
  Video_Export,
} from "../../assets/images";
import "react-toastify/dist/ReactToastify.css";

import { Modal, Spinner } from "react-bootstrap";
import screenfull from "screenfull";
import { addMinutes, subMinutes, differenceInMinutes } from "date-fns";
import { toast } from "react-toastify";

import {
  GetHooterPanelDetails,
  HooterOnOffClick,
  LocalHooterRequest,
  TwoWayCommunicationRequest,
  VideoExport,
  alertCreation,
  attachalertevidences,
  checkFileDownloaded,
  localFileDownload,
  takeZeroDataPresent,
} from "../../services/alertAuthService";
import {
  addrasaconversationindb,
  getstreamingurl,
} from "../../services/chatFlowService";
import { addDownload } from "../../services/downloadService";

import PopupCard from "./PopupCard";

import { WarningToast } from "../../CustomHooks/WarningToast";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { usePageVisibility } from "../../CustomHooks/usePageVisibility";
import {
  ConvertDate,
  ConvertDateThree,
  formatJSDateInDDMMYYYY,
  multiTimeZoneHelper,
} from "../../utils/utils";
import { CAMERA_SINGLE_PLAYBACK } from "../../navigation/CONSTANTS";
import {
  CHAT_CAM_CHANGES,
  CLOSE_CHATFLOW_BTN,
  FILE_DOWNLOAD_CHECK_WAIT_TIME,
  HIDE_STUFF,
  IS_PTZVISIBLE,
  MULTI_TIME_ZONE,
  SPINNER_WAIT_TIME,
  AUTO_ALERT_CLOSE,
  SHOW_VISUAL_COMPONENTS,
  WS_PORT,
  WS_SERVER,
  CAMERA_LATEST_STATUS,
  PTZ_CONTROL_SPEED
} from "../../config";
import { getManualAlertCode } from "../../services/alertAuthService";
import { Tooltip } from "@mui/material";

import {
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RecLiveIndicator from "./RecLiveIndicator";
import { getLatestCameraStatus } from "../../services/healthMonitoringService";
import { callPTZPreset, getPTZPresets, ptzControl } from "../../services/onVifService";
import { callingHomePosition } from "../../services/onVifService";



const WAIT_TIME = 20000;
const RETRY_TIME = 30000;

const WebRTCPlayer = ({
  id,
  url,
  isEncode,
  upperDivCss,
  videoCss,
  item,
  fullVideoCss,
  buttonCss,
  alertCameraHeadingCss,
  alertCameraDetailCss,
  actualTime,
  alertDetail,
  playback,
  prePostDisplay,
  liveButton,
  isSinglePlayback,
  noStreamDivCss,
  exportCurrentVideoHide,
  videoExportDownload,
  exportStartTime,
  exportEndTime,
  isMultiPlay,
  differenceSecondsMain,
  secondsDiff,
  showPlaybackBtn,
  devId,
  hideTwoWay,
  imageToChat,
  showPrePostReplay,
  showAlertCreation,
  showHooterIcon,
  associateCam,
  setAssociateCam,
  showDirectToChat,
  attachEvidence,
  buttonDisable,
  displayInfo,
  alertData,
  chatFlowClicked,
  isSelected,
  setStartDateString,
  setEndDateString,
  setStartMode,
  // closedAlertBtn,
  setAlertToClose,
  showName,
  stretchVideo,
  showAuthorizeBtn,
  authorizeDevice,
  showStartTimeStampBtn,
  startTimeDevice,
  isExportFuncAllowed = true,
  isPlaybackFuncAllowed = true,
  setCloseAlertId,
  closeAlertFromModal,
  setCloseReason
}) => {
  let connect_attempts = 0;
  let peer_connection;
  let send_channel;
  let ws_conn;
  let peer_id;
  let ws_port = "8444";
  let ws_server = "127.0.0.1";
  let local_stream_promise;
  let msg;
  let sdp;
  let textarea;
  let setError;
  let scaleFactor = 0.25;
  var rtc_configuration = { iceServers: [] };
  var default_constraints = { video: false, audio: true };
  
  let history = useHistory();

  const { isonvif = 0, onvifusername = '', onvifuserpassword = '' } = item || {};
  const isVisible = usePageVisibility();
  //#region useState start
  const [played, setPlayed] = useState(0);
  const [videoId, setVideoId] = useState(id);
  const [liveId, setLiveId] = useState(id);
  const [videoUrl, setVideoUrl] = useState(url);
  const [liveUrl, setLiveUrl] = useState(url);
  const [liveMode, setLiveMode] = useState(true);
  const [playbackMode, setPlaybackMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tempEvent, setTempEvent] = useState(null);
  const [popOpen, setPopOpen] = useState(false);
  const [snapModal, setSnapModal] = useState(false);
  const [PTZConfigurationModal, setPTZConfigurationModal] = useState(false);
  const [alertCreationModal, setAlertCreationModal] = useState(false);
  const [mode, setMode] = useState("");
  const [isSoundOn, setIsSoundOn] = useState(true);
  const [isFullscreenClick, setIsFullscreenClick] = useState(false);
  const videoContainerParentRef = useRef(null);
  const videoContainerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [zoomValue, setZoomValue] = useState(1);
  const [tiltValue, setTiltValue] = useState(1);
  const [focusValue, setFocusValue] = useState(1);
  const [presetList, setPresetList] = useState([]);
  const [presetData, setPresetData] = useState([]);
  const [selectedPreset, setSelectedPreset] = useState({});
  const [presetListLoading, setPresetListLoading] = useState(false);
  const [ptzControlLoading, setControlPtzLoading] = useState(false);

  const toggleMute = () => {
    const vid = videoContainerRef?.current;
    const newMuted = !isMuted;
    if (vid) {
      try {
        vid.muted = newMuted;
      } catch (e) {
        // ignore
      }
    }
    setIsMuted(newMuted);
  };

  useEffect(() => {
    const vid = videoContainerRef?.current;
    if (vid) vid.muted = isMuted;
  }, [isMuted]);
  const [date, setDate] = useState(subMinutes(new Date(), 15));
  const [dateString, setDateString] = useState("");
  const [dateStringTwo, setDateStringTwo] = useState("");
  const [timeString, setTimeString] = useState("");
  const [timeStringTwo, setTimeStringTwo] = useState("");
  const [timeStringMain, setTimeStringMain] = useState("+15 min");
  const [timeStringMainTwo, setTimeStringMainTwo] = useState("+5 min");
  const [differenceTime, setDifferenceTime] = useState(15);
  const [differenceTimeTwo, setDifferenceTimeTwo] = useState(15);
  const [blankDate, setBlankDate] = useState("");
  const [blankDateTwo, setBlankDateTwo] = useState("");
  const [dateTwo, setdateTwo] = useState(new Date());
  const [activeSide, setActiveSide] = useState("start");
  const [isAllinOneHooterOn, setIsAllinOneHooterOn] = useState(false);
  const [streamFound, setStreamFound] = useState(true);
  const [helperState, setHelperState] = useState(false);
  const [reconnectState, setReconnectState] = useState(false);
  const [webRTCexportStartTime, setWebRTCExportStartTime] =
    useState(exportStartTime);
  const [webRTCexportEndTime, setWebRTCExportEndTime] = useState(exportEndTime);
  const [webRTCExportCurrentVideoHide, setWebRTCExportCurrentVideoHide] =
    useState(exportCurrentVideoHide);
  const [runningTime, setRunningTime] = useState("00:00:00");
  const [totalTime, setTotalTime] = useState("00:15:00");
  const [webSocketState, setWebSocketState] = useState(null);
  const [timer, setTimer] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isOver, setIsOver] = useState(false);
  const [differenceInSeconds, setDifferenceInSeconds] = useState(900);
  const [timerInt, setTimerInt] = useState(null);
  const [pauseTimer, setPausedTimer] = useState(null);
  const [downloadingLocal, setDownloadingLocal] = useState(false);
  const [disableAlertCreation, setDisableAlertCreation] = useState(false);
  const [disableHooterBtn, setDisableHooterBtn] = useState(false);
  const [isPtzClick, setIsPtzClick] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const[buttonDisableZeroDay,setButtonDisableZeroDay] = useState(false)
  const[videoScale, setVideoScale] = useState(1)
  const [zoomCenter, setZoomCenter] = useState({ x: 50, y: 50 }); // Center as percentage
  const [alertTypeList, setAlertTypeList] = useState([]);
  const [createAlertForId, setCreateAlertForId] = useState(null);
  const [showCloseOptions, setShowCloseOptions] = useState(false);
  const [selected, setSelected] = useState("");
  const [open, setOpen] = useState(false);
  const [alertComments, setAlertComments] = useState("");
  const [latestStatus, setLatestStatus] = useState("");

  const handleSelect = (value) => {
    setSelected(value);
    setCloseReason(value);
  };

  const handleApply = () => {
    setOpen(false);
    closeAlertFromModal();
  };

  const closeureAlertReasons = [
      "False Alarm", "Agency Check", "Audit Check", "AM Security Check", "Technical issue", 
      "BH /AH /RM check", "Maintenance / HO check", "Vigilance check"
  ]

   const closedAlertBtn = (alertId) => {
      setShowCloseOptions(true)
      setOpen((prev) => !prev)
      // setCloseAlertModal(true)
      setCloseAlertId(alertId);
   }
  
  //#endregion useState end

  // Track selected alert type for alert creation
  const [selectedAlertType, setSelectedAlertType] = useState('default');

  // const isExportAllowed = useMemo(() => showFunction('export'), [showFunction]);
  // const isPlaybackAllowed = useMemo(() => showFunction('playback'), [showFunction]);

  //#region useEffect start
  useEffect(() => {
    if (isSinglePlayback && webSocketState != null) {
      if (isVisible) {
        webSocketState.send("Play");
        setIsPaused(false);
      } else {
        webSocketState.send("Pause");
        setIsPaused(true);
      }
    }
  }, [isVisible]);

  useEffect(() => {
    if (isSinglePlayback) {
      if (isPaused) {
        clearTimeout(pauseTimer);
        let pausedTimer = setTimeout(() => {
          setIsOver(true);
        }, 90000);
        setPausedTimer(pausedTimer);
      } else {
        clearTimeout(pauseTimer);
      }
    }
  }, [isPaused]);

  useEffect(() => {
    webSocketServerConnect();

    return () => {
      ws_conn.close();
      resetVideo();
      if (peer_connection) {
        peer_connection.close();
        peer_connection = null;
      }
    };
  }, [videoUrl]);

  useEffect(() => {
    let min = secondsDiff / 60;
    let str;
    if (min < 10) {
      str = `00:0${min}:00`;
    } else {
      str = `00:${min}:00`;
    }
    // setTotalTime(str);
  }, [secondsDiff]);

  useEffect(() => {
    if (!loading) {
      if (getVideoElement()?.srcObject !== tempEvent?.streams[0]) {
        setTimer(0);
        setRunningTime(secondsToHHMMSS(0));
        setIsOver(false);
        if (getVideoElement() != null) {
          let remoteStream = tempEvent.streams[0];

          getVideoElement().srcObject = tempEvent?.streams[0];
          const audioTracks = remoteStream.getAudioTracks();
          if (audioTracks.length > 0) {
          //alert("Audio");
          getVideoElement().muted = true;
              audioTracks.forEach(track => track.enabled = false);
              console.log("🔇 Audio is muted by default");
          } 
        } else {
          restartPlayer();
        }
      }
    }
  }, [loading]);

  useEffect(() => {
    document.addEventListener("fullscreenchange", exitHandler);
    function exitHandler() {
      if (
        !document.fullscreenElement &&
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      ) {
        setIsFullscreenClick(false);
      } else {
      }
    }
    return () => {
      document.removeEventListener("fullscreenchange", exitHandler);
    };
  }, [isFullscreenClick]);

  useEffect(() => {
    let currentTime;
    if (MULTI_TIME_ZONE) {
      currentTime = multiTimeZoneHelper(item.OffsetMinutes);
    } else {
      currentTime = new Date();
    }
    let d = subMinutes(currentTime, 15);
    let temp = ConvertDate(d);
    let temp_date = temp.slice(0, 10).replace(/-/g, "_");
    setDateString(temp_date);
  }, []);

  useEffect(() => {
    let d;
    if (MULTI_TIME_ZONE) {
      d = multiTimeZoneHelper(item.OffsetMinutes);
    } else {
      d = new Date();
    }
    let temp = ConvertDate(d);
    let temp_date = temp.slice(0, 10).replace(/-/g, "_");
    setDateStringTwo(temp_date);
  }, []);

  useEffect(() => {
    if (snapModal) {
      if (isFullscreenClick) {
        handleFullScreen();
      }
      shoot();
    }
  }, [snapModal]);



  useEffect(() => {
    if (!CAMERA_LATEST_STATUS) {
return;
    }
      
  // Call API to update device stream status
  if(streamFound && !loading){
    let deviceId = item.ParentCameraID || devId;
    console.log("Online Status for Device ID:", deviceId);
    getLatestCameraStatus(deviceId, "online")
      .then((res) => {
        if(res && res.Status === "success"){
          setLatestStatus(res.Data);
          console.log("Camera status updated:", res.Data);
        }
      })
      .catch((err) => {
        console.error("Error fetching camera status:", err);
      });
  }

  if(!streamFound && loading){
    let deviceId = item.ParentCameraID || devId;
    getLatestCameraStatus(deviceId, "offline")
      .then((res) => {
        if(res && res.Status === "success"){
          setLatestStatus(res.Data);
          console.log("Camera status updated:", res.Data);
        }
      })
      .catch((err) => {
        console.error("Error fetching camera status:", err);
      });
  }
  console.log({streamFound, displayInfo, loading})
},[streamFound, loading])

  //For Getting No Stream View
  useEffect(() => {
    let timer = setTimeout(() => {
      if (displayInfo) {
        return;
      }
      if (loading) {
        setStreamFound(false);
        setHelperState(true);
        setReconnectState(false);
        webSocketState?.close();
        resetVideo();
        if (peer_connection) {
          peer_connection.close();
          peer_connection = null;
        }
      }
    }, WAIT_TIME);

    return () => {
      clearTimeout(timer);
    };
  }, [loading, reconnectState]);

  //For Getting Loading Streaming View
  useEffect(() => {
    // if (displayInfo) {
    //   return;
    // }
    if (helperState && !liveMode) {
      setStreamFound(true);
      setLoading(true);
      setReconnectState(true);
      setHelperState(false);
      WarningToast(
        "Playback stream could not be found, going back to live stream."
      );
      goBackToLive();
      return;
    }
    if (helperState) {
      let timerTwo = setTimeout(() => {
        setStreamFound(true);
        reConnection();
        setReconnectState(true);
        setHelperState(false);
      }, RETRY_TIME);
      return () => {
        clearTimeout(timerTwo);
      };
    }
  }, [helperState]);

  useEffect(() => {
    if (isSinglePlayback) {
      if (webSocketState != null) {
        clearTimeout(timerInt);
        const newTimer = setTimeout(() => {
          if (isPaused) {
            webSocketState.send("Play");
            setIsPaused(false);
          }
          webSocketState.send("seek " + played);
        }, 500);
        setTimerInt(newTimer);
      }
    }
  }, [played]);

  useEffect(() => {
    if (isSinglePlayback) {
      let interval = setInterval(() => {
        let timePlayed;
        if (differenceInSeconds <= timer) {
          timePlayed = timer;
          setIsOver(true);
        } else {
          if (isPaused) {
            timePlayed = timer;
          } else {
            timePlayed = timer + 1;
          }
        }
        setRunningTime(secondsToHHMMSS(timePlayed));
        setTimer(timePlayed);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [timer, isPaused]);

  useEffect(() => {
    let timer;
    if (downloadingLocal) {
      //To Set Timeout of 20 seconds and then display the loader overlay;
      timer = setTimeout(() => {
        setDownloadingLocal(false);
        SuccessToast("Check your downloads folder for exported video");
      }, SPINNER_WAIT_TIME);
    }
    return () => clearTimeout(timer);
  }, [downloadingLocal]);

  useEffect(() => {
    let indivTimer;
    if(AUTO_ALERT_CLOSE){
      if(displayInfo){
        indivTimer = setTimeout(() => {
          if(!isSelected){
            setAlertToClose((prevItems) => [...prevItems, alertData.alertId])
          }
        }, 20000)
      }
    }
    return () => clearTimeout(indivTimer);
  }, [isSelected])

  // Digital zoom useEffect (without panning)
  useEffect(() => {
    const videoEl = videoContainerRef.current;
    if (!videoEl || item?.IsPTZ == "1") return;

    // Mouse wheel for zoom at cursor
    const handleWheel = (e) => {
      e.preventDefault();
      
      const rect = videoEl.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      
      // Calculate mouse position as percentage
      const percentX = (mouseX / rect.width) * 100;
      const percentY = (mouseY / rect.height) * 100;
      
      // Calculate zoom delta
      const zoomDelta = e.deltaY < 0 ? 0.2 : -0.2;
      const newScale = Math.max(1, Math.min(5, videoScale + zoomDelta));
      
      if (newScale === 1) {
        // Reset everything when zooming out to 1x
        setVideoScale(1);
        setZoomCenter({ x: 50, y: 50 }); // Reset to center
      } else {
        // Set zoom center to cursor position
        setVideoScale(newScale);
        setZoomCenter({ x: percentX, y: percentY });
      }
    };

    videoEl.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      videoEl.removeEventListener('wheel', handleWheel);
    };
  }, [loading, videoScale]); // Simplified dependencies

  //#endregion useEffect end

  //#region functions start
  const goBackToLive = () => {
    setVideoId(liveId);
    setVideoUrl(liveUrl);
    setLiveMode(true);
    setPlaybackMode(false);
    setWebRTCExportCurrentVideoHide(true);
    setStartMode(true);
    if (CHAT_CAM_CHANGES) {
      if (associateCam != null || associateCam != undefined) {
        let text = `${
          item.CameraName || item.cameraName || item.deviceName
        } -  Live Stream played.`;
        associateAttach(text);
      }
    }
  };
// console.log("itemdeviceid", item)
  const getAlertType = () => {
      try {

        getManualAlertCode(item.ParentCameraID).then((resp) => {
          // console.log("itemdeviceid", item)
          if (resp != undefined) {
            if (resp.Status == "success") {
              let alerttypeArray = resp.Data.map((item) => ({
                
                value: item.AlertCode,
                label: item.AlertAssociated,
                AlertCodeId: item.AlertCodeId
              })).sort((a, b) => a.label.localeCompare(b.label))
              setAlertTypeList(alerttypeArray)
            } else {
              setAlertTypeList(null)
            }
          }
        })
      } catch (error) {
        console.error(error)
      }
    }

  const restartPrePost = () => {
    let randomNum = Math.floor(Math.random() * 100);
    reConnectionTwo(videoId + "" + randomNum);
  };

  const restartPlayer = () => {
    let randomNum = Math.floor(Math.random() * 100);
    reConnectionTwo(videoId + "" + randomNum);
  };

  const webSocketServerConnect = () => {
    setLoading(true);
    connect_attempts++;
    if (connect_attempts > 3) {
      // setError("Too many connection attempts, aborting. Refresh page to try again");
      return;
    }
    peer_id = videoId;
    //let ws_url = "ws://" + WS_SERVER + ":" + WS_PORT;
    let ws_url = "ws://" + ws_server + ":" + ws_port;
    ws_conn = new WebSocket(ws_url);
    setWebSocketState(ws_conn);
    /* When connected, immediately register with the server */
    let tempIsEncode = isEncode;
    if (playbackMode) {
      tempIsEncode = item.isPlaybackTranscoded;
    }

    ws_conn.addEventListener("open", (event) => {
      let brandName = item.BrandName || item.brandName;
      let interfaceType = item.CCTVType || item.cctvtype
      let commPort = item.CommunicationPort || item.communicationPort;
      if (brandName != 0) {
        if (brandName.includes(" ")) {
          brandName = brandName.replace(/\s/g, "");
        }
      }
      let isPTZ = item.IsPTZ == "1" ? item.IsPTZ : "0";
      let brandInterfaceType = `${brandName}-${interfaceType}`;
      console.log("INTERFACETYPECHECK", brandInterfaceType)
      ws_conn.send(
        "HELLO " +
          peer_id +
          " " +
          videoUrl +
          " " +
          tempIsEncode +
          " 0" +
          " " +
          brandInterfaceType +
          " " +
          isPTZ +
          " " +
          commPort
      );
    });
    ws_conn.addEventListener("error", onServerError);
    ws_conn.addEventListener("message", onServerMessage);
    ws_conn.addEventListener("close", onServerClose);
  };

  const webSocketServerConnectTwo = (localId) => {
    setLoading(true);
    connect_attempts++;
    if (connect_attempts > 3) {
      // setError("Too many connection attempts, aborting. Refresh page to try again");
      return;
    }
    // Fetch the peer localId to use
    peer_id = localId;
    //let ws_url = "ws://" + WS_SERVER + ":" + WS_PORT;
    let ws_url = "ws://" + ws_server + ":" + ws_port;
    ws_conn = new WebSocket(ws_url);
    setWebSocketState(ws_conn);
    /* When connected, immediately register with the server */
    ws_conn.addEventListener("open", (event) => {
      // ws_conn.send('HELLO ' + peer_id + " " + videoUrl + ' ' + isEncode + ' 0');
      let brandName = item.BrandName || item.brandName;
      let interfaceType = item.CCTVType || item.cctvtype
      let commPort = item.CommunicationPort || item.communicationPort;
      if (brandName != 0) {
        if (brandName.includes(" ")) {
          brandName = brandName.replace(/\s/g, "");
        }
      }
      let isPTZ = item.IsPTZ == "1" ? item.IsPTZ : "0";
      let brandInterfaceType = `${brandName}-${interfaceType}`;
      console.log("INTERFACETYPECHECK", brandInterfaceType)
      ws_conn.send(
        "HELLO " +
          peer_id +
          " " +
          videoUrl +
          " " +
          isEncode +
          " 0" +
          " " +
          brandInterfaceType +
          " " +
          isPTZ +
          " " +
          commPort
      );
    });
    ws_conn.addEventListener("error", onServerError);
    ws_conn.addEventListener("message", onServerMessage);
    ws_conn.addEventListener("close", onServerClose);
  };

  const onServerError = (event) => {};

  const onServerMessage = (event) => {
    switch (event.data) {
      case "HELLO":
        ws_conn.send("SESSION " + peer_id);
        return;
      case "SESSION_OK":
        return;
      default:
        if (event.data.startsWith("ERROR")) {
          handleIncomingError(event.data);
          return;
        }
        if (event.data.startsWith("OFFER_REQUEST")) {
          // The peer wants us to set up and then send an offer
          if (!peer_connection) {
            peer_connection = new RTCPeerConnection(rtc_configuration);
            send_channel = peer_connection.createDataChannel("label", null);
            send_channel.onopen = handleDataChannelOpen;
            send_channel.onmessage = handleDataChannelMessageReceived;
            send_channel.onerror = handleDataChannelError;
            send_channel.onclose = handleDataChannelClose;
            peer_connection.ondatachannel = onDataChannel;
            peer_connection.ontrack = onRemoteTrack;
            local_stream_promise = getLocalStream()
              .then((stream) => {
                peer_connection?.addStream(stream);
                return stream;
              })
              .catch(setError);
          }
          // createCall(null).then(generateOffer);
        } else {
          // Handle incoming JSON SDP and ICE messages
          try {
            msg = JSON.parse(event.data);
          } catch (e) {
            if (e instanceof SyntaxError) {
              handleIncomingError("Error parsing incoming JSON: " + event.data);
            } else {
              handleIncomingError(
                "Unknown error parsing response: " + event.data
              );
            }
            return;
          }

          // Incoming JSON signals the beginning of a call
          if (!peer_connection) {
            peer_connection = new RTCPeerConnection(rtc_configuration);
            send_channel = peer_connection.createDataChannel("label", null);
            send_channel.onopen = handleDataChannelOpen;
            send_channel.onmessage = handleDataChannelMessageReceived;
            send_channel.onerror = handleDataChannelError;
            send_channel.onclose = handleDataChannelClose;
            peer_connection.ondatachannel = onDataChannel;
            peer_connection.ontrack = onRemoteTrack;
            local_stream_promise = getLocalStream()
              .then((stream) => {
                peer_connection?.addStream(stream);
                return stream;
              })
              .catch(setError);
          }

          // createCall(msg);

          if (msg.sdp != null) {
            onIncomingSDP(msg.sdp);
          } else if (msg.ice != null) {
            onIncomingICE(msg.ice);
          } else {
            handleIncomingError("Unknown incoming JSON: " + msg);
          }
        }
    }
  };

  const generateOffer = () => {
    peer_connection.createOffer().then(onLocalDescription).catch(setError);
  };

  const onIncomingSDP = (sdp) => {
    peer_connection
      .setRemoteDescription(sdp)
      .then(() => {
        if (sdp.type != "offer") return;
        peer_connection.createAnswer();
        local_stream_promise
          .then((stream) => {
            peer_connection
              ?.createAnswer()
              .then(onLocalDescription)
              .catch(setError);
          })
          .catch(setError);
      })
      .catch(setError);
  };

  const onLocalDescription = (desc) => {
    peer_connection?.setLocalDescription(desc).then(function () {
      sdp = { sdp: peer_connection.localDescription };
      ws_conn.send(JSON.stringify(sdp));
    });
  };

  const onIncomingICE = (ice) => {
    let candidate = new RTCIceCandidate(ice);
    peer_connection.addIceCandidate(candidate).catch(setError);
  };

  const onServerClose = (event) => {
    resetVideo();
    if (peer_connection) {
      peer_connection.close();
      peer_connection = null;
    }
  };

  const resetVideo = () => {
    if (local_stream_promise)
      local_stream_promise.then((stream) => {
        if (stream) {
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
        }
      });

    // Reset the video element and stop showing the last received frame
    var videoElement = getVideoElement();
    if (videoElement != null) {
      videoElement.pause();
      videoElement.src = "";
      videoElement.load();
    }
  };

  const getVideoElement = () => {
    return document.getElementById(videoId);
  };

  const handleIncomingError = (error) => {
    resetState();
  };

  const resetState = () => {
    ws_conn.close();
  };

  const playVideo = () => {
    webSocketState.send("Play");
    setIsPaused(false);
  };

  const pauseVideo = () => {
    webSocketState.send("Pause");
    setIsPaused(true);
  };

  const ptzControlFunc = async (command) => {
    const payload = {
      "ip": `${item.privateIPAddress}:${item.httpPort}`,
      "username": item.onvifusername || "",
      "password": item.onvifuserpassword || "",
      "action": command,
      "speed": PTZ_CONTROL_SPEED
    }
    setControlPtzLoading(true);
    ptzControl(payload).then((res) => {
      if(res && res.Status === "success"){
        setControlPtzLoading(false);
        //SuccessToast(res.Message);
      }
      else{
        setControlPtzLoading(false);
        ErrorToast(res.Message);
      }
    }).catch((err) => {
      setControlPtzLoading(false);
        ErrorToast("Error sending PTZ command");
        console.error("Error sending PTZ command:", err);
    });
    
  };

  async function Left() {
    //send_channel.send("Replay");
    if(isonvif){
      await ptzControlFunc("move left");
      return;
    }
    webSocketState.send("left");
  }

  async function Right() {
    //send_channel.send("Replay");
    if(isonvif){
      await ptzControlFunc("move right");
      return;
    }
    webSocketState.send("right");
  }

  async function Up() {
    //send_channel.send("Replay");
    if(isonvif){
      await ptzControlFunc("tilt up");
      return;
    }
    webSocketState.send("up");
  }

  async function Down() {
    //send_channel.send("Replay");
    if(isonvif){
      await ptzControlFunc("tilt down");
      return;
    }
    webSocketState.send("down");
  }

  function ZoomIn() {
    //send_channel.send("Replay");
    webSocketState.send("zoomin");
  }

  function ZoomOut() {
    //send_channel.send("Replay");
    webSocketState.send("zoomout");
  }

  const setZoom = async (action) => {
    if(isonvif){
      switch(action){
        case 'IN':
          action = "zoom in";
          break;
        case 'OUT':
          action = "zoom out";
          break;
        default:
          return;
      }
      await ptzControlFunc(action);
      return;
    }  

    if (action === 'IN') {
      setVideoScale(prev => Math.min(5, prev + 0.2));
    } else if (action === 'OUT') {
      setVideoScale(prev => {
        const newScale = Math.max(1, prev - 0.2);
        // Reset zoom center when zooming out to 1x
        if (newScale === 1) {
          setZoomCenter({ x: 50, y: 50 });
        }
        return newScale;
      });
    }
  }

  const restartVideo = () => {
    if (isOver) {
      let randomNum = Math.floor(Math.random() * 100);
      reConnectionTwo(videoId + "" + randomNum);
      setIsOver(false);
    } else {
      if (isPaused) {
        webSocketState.send("Play");
        setIsPaused(false);
      }
      webSocketState.send("Replay");
      setRunningTime(secondsToHHMMSS(0));
      setTimer(0);
    }
  };

  const createCall = (msg) => {
    connect_attempts = 0;

    peer_connection = new RTCPeerConnection(rtc_configuration);
    send_channel = peer_connection.createDataChannel("label", null);
    send_channel.onopen = handleDataChannelOpen;
    send_channel.onmessage = handleDataChannelMessageReceived;
    send_channel.onerror = handleDataChannelError;
    send_channel.onclose = handleDataChannelClose;
    peer_connection.ondatachannel = onDataChannel;
    peer_connection.ontrack = onRemoteTrack;
    /* Send our video/audio to the other peer */
    local_stream_promise = getLocalStream()
      .then((stream) => {
        peer_connection.addStream(stream);
        return stream;
      })
      .catch(setError);

    if (msg != null && !msg.sdp) {
      console.log("WARNING: First message wasn't an SDP message!?");
    }

    peer_connection.onicecandidate = (event) => {
      // We have a candidate, send it to the remote party with the
      // same uuid
      if (event.candidate == null) {
      } else {
        ws_conn.send(JSON.stringify({ ice: event.candidate }));
      }
    };

    if (msg != null)
      console.log("Created peer connection for call, waiting for SDP");
    return local_stream_promise;
  };

  const handleDataChannelOpen = (event) => {
  };

  const handlePTZPresetConfiguration = async (item) => {
    const { privateIPAddress, httpPort, onvifusername = '', onvifuserpassword = '' } = item || {}; 

    const IPValue = privateIPAddress
      ? httpPort == 80
        ? privateIPAddress
        : `${privateIPAddress}:${httpPort}`
      : "";

    setPTZConfigurationModal(true);
    setPresetListLoading(true);
    getPTZPresets(IPValue, onvifusername, onvifuserpassword).then((res) => {
      if (res && res.Status === "success") {
        setPresetData(res.Data);
        setPresetList(res.Data?.presets || []);
        setPresetListLoading(false);
      }
    }).catch((err) => {
      console.error("Error fetching PTZ presets:", err);
        setPresetListLoading(false);
    });
  }

  const onPresetCallBtnClick = async () => {
    const { privateIPAddress, httpPort, onvifusername = '', onvifuserpassword = '' } = item || {}; 
    const IPValue = privateIPAddress
      ? httpPort == 80
        ? privateIPAddress
        : `${privateIPAddress}:${httpPort}`
      : "";
    const payload = {
      "ip": IPValue,
      "username": onvifusername,
      "password": onvifuserpassword,
      "preset_name": selectedPreset?.Name || "",
      "preset_token": selectedPreset?.Token || ""
    }


    callPTZPreset(payload).then((res) => {
        if(res && res.Status === "success"){
          SuccessToast(res.Message);
        }
    }).catch((err) => {
      console.error("Error calling PTZ preset:", err);
    });
  }

  const onPresetModalClose = () => {
    setPTZConfigurationModal(false);
    setPresetList([]);
    setPresetData([]);
  }

  const handleDataChannelMessageReceived = (event) => {
    if (typeof event.data === "string" || event.data instanceof String) {
      textarea = document.getElementById("text");
      textarea.value = textarea.value + "\n" + event.data;
    } else {
    }
    send_channel.send("Hi! (from browser)");
  };

  const handleDataChannelError = (error) => {
  };

  const handleDataChannelClose = (event) => {
  };

  function onDataChannel(event) {
    let receiveChannel = event.channel;
    receiveChannel.onopen = handleDataChannelOpen;
    receiveChannel.onmessage = handleDataChannelMessageReceived;
    receiveChannel.onerror = handleDataChannelError;
    receiveChannel.onclose = handleDataChannelClose;
  }

  function onRemoteTrack(event) {
    setLoading(false);
    setTempEvent(event);
  }

  // function getLocalStream() {
  //   var constraints;
  //   try {
  //     constraints = default_constraints;
  //   } catch (e) {
  //     console.error(e);
  //     constraints = default_constraints;
  //   }
  //   //return null;
  //   // Add local stream
  //   if (navigator.mediaDevices.getUserMedia) {
  //     return navigator.mediaDevices.getUserMedia(constraints);
  //   } else {
  //     errorUserMediaHandler();
  //   }
  // }

  function createSilentAudioTrack() {
    const ctx = new AudioContext();
    const oscillator = ctx.createOscillator();
    const dst = oscillator.connect(ctx.createMediaStreamDestination());
    oscillator.start();
    return dst.stream.getAudioTracks()[0];
  }
  
  function getLocalStream() {
      var constraints;
      constraints = default_constraints;
      console.log("Constraints", JSON.stringify(constraints));
      if (constraints.audio) {
        const silentTrack = createSilentAudioTrack(); // your function
          const fakeStream = new MediaStream([silentTrack]);
          return Promise.resolve(fakeStream);  
      }
  
      /*if (navigator.mediaDevices.getUserMedia) { 
    return navigator.mediaDevices.getUserMedia(constraints);
      } else {
          errorUserMediaHandler();
      }*/
  }
  
   

  function errorUserMediaHandler() {
  }

  const handleFullScreen = () => {
    screenfull.toggle(videoContainerParentRef.current);
    setIsFullscreenClick(!screenfull.isFullscreen);
  };

  const dateChangeStart = (v) => {
    let d = ConvertDate(v);
    let temp = d.slice(0, 10).replace(/-/g, "_");
    setDateString(temp);
    setDate(v);
    setActiveSide("start");
    if (!dateStringTwo) {
      setDateStringTwo(temp);
      setdateTwo(v);
    }
  };

  const dateChangeEnd = (v) => {
    let d = ConvertDate(v);
    let temp = d.slice(0, 10).replace(/-/g, "_");
    setDateStringTwo(temp);
    setdateTwo(v);
    setActiveSide("end");
  };

  const getDataFromChild = (data) => {
    let timeStringMain = "";
    if (data === "") {
      let blankArr = blankDate.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMain = blankStr;
    } else {
      timeStringMain = data;
    }
    let temp = dateString + "_" + timeStringMain;
    let arr = temp.split("_");
    let SD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    let currentTime = new Date();
    if (MULTI_TIME_ZONE) {
      currentTime = multiTimeZoneHelper(item.OffsetMinutes);
    }
    const difference = differenceInMinutes(currentTime, SD);

    // Validation for start time
    if (mode == "Playback") {
      if (SD > currentTime) {
        WarningToast("Start time cannot be in the future!");
        setTimeString("");
        return;
      }
    } else if (mode == "Export" && difference < 60 && difference >= 0) {
      WarningToast("Selected Time is less than 60 min !");
      timeStringMain = "+" + difference + " min ";
      setDifferenceTimeTwo(parseInt(difference));
      setTimeStringMainTwo(timeStringMain);
    } else if (mode == "Export") {
      setDifferenceTimeTwo(60);
      setTimeStringMainTwo("+60 min");
    }

    setTimeString(data);
    // If end time already selected, update duration preview
    if (timeStringTwo !== "") {
      // parse potential end
      let tMain = timeString === "" ? blankDate : timeString;
      let tempStart = dateString + "_" + tMain;
      let arrStart = tempStart.split("_");
      let SD2 = new Date(arrStart[0], arrStart[1] - 1, arrStart[2], arrStart[3], arrStart[4], arrStart[5]);

      let tMainTwo = timeStringTwo === "" ? blankDateTwo : timeStringTwo;
      let tempEnd = dateStringTwo + "_" + tMainTwo;
      let arrEnd = tempEnd.split("_");
      let ED2 = new Date(arrEnd[0], arrEnd[1] - 1, arrEnd[2], arrEnd[3], arrEnd[4], arrEnd[5]);

      const diffMins = differenceInMinutes(ED2, SD2);
      if (diffMins > 0) {
        setDifferenceInSeconds(diffMins * 60);
        setTotalTime(secondsToHHMMSS(diffMins * 60));
      }
    }
  };

  const getDataFromChildTwo = (data) => {
    let timeStringMainTwo = "";
    if (data === "") {
      let blankArr = blankDateTwo.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMainTwo = blankStr;
    } else {
      timeStringMainTwo = data;
    }
    let temp = dateStringTwo + "_" + timeStringMainTwo;
    let arr = temp.split("_");
    let ED = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    let currentTime = new Date();
    if (MULTI_TIME_ZONE) {
      currentTime = multiTimeZoneHelper(item.OffsetMinutes);
    }

    // For playback mode, validate end time
    if (mode == "Playback") {
      if (ED > currentTime) {
        WarningToast("End time cannot be in the future!");
        setTimeStringTwo("");
        return;
      }
      // Just set the end time, no automatic calculation
      setTimeStringMainTwo(timeStringMainTwo);
    } else if (mode == "Export") {
      // For export mode, maintain existing logic
      const difference = differenceInMinutes(currentTime, ED);
      if (difference < 60 && difference >= 0) {
        WarningToast("Selected Time is less than 60 min !");
        timeStringMainTwo = difference + " min ";
        setDifferenceTimeTwo(parseInt(difference));
        setTimeStringMainTwo(timeStringMainTwo);
      } else {
        setDifferenceTimeTwo(60);
        setTimeStringMainTwo("60 min");
      }
    }

    setTimeStringTwo(data);
    // If start time already selected, update duration preview
    if (timeString !== "") {
      let tMain = timeString === "" ? blankDate : timeString;
      let tempStart = dateString + "_" + tMain;
      let arrStart = tempStart.split("_");
      let SD2 = new Date(arrStart[0], arrStart[1] - 1, arrStart[2], arrStart[3], arrStart[4], arrStart[5]);

      let tMainTwo = timeStringTwo === "" ? blankDateTwo : timeStringTwo;
      let tempEnd = dateStringTwo + "_" + tMainTwo;
      let arrEnd = tempEnd.split("_");
      let ED2 = new Date(arrEnd[0], arrEnd[1] - 1, arrEnd[2], arrEnd[3], arrEnd[4], arrEnd[5]);

      const diffMins = differenceInMinutes(ED2, SD2);
      if (diffMins > 0) {
        setDifferenceInSeconds(diffMins * 60);
        setTotalTime(secondsToHHMMSS(diffMins * 60));
      }
    }
  };

  const onSubmitBtn = () => {
    // Handle Start Date/Time
    let timeStringMain = "";
    if (timeString === "") {
      let blankArr = blankDate.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMain = blankStr;
    } else {
      timeStringMain = timeString;
    }
    let temp = dateString + "_" + timeStringMain;
    let arr = temp.split("_");
    let SD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    let startString = ConvertDate(SD);

    // Handle End Date/Time (User Selected)
    let timeStringMainTwo = "";
    if (timeStringTwo === "") {
      let blankArr = blankDateTwo.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMainTwo = blankStr;
    } else {
      timeStringMainTwo = timeStringTwo;
    }
    let tempEnd = dateStringTwo + "_" + timeStringMainTwo;
    let arrEnd = tempEnd.split("_");
    let ED = new Date(arrEnd[0], arrEnd[1] - 1, arrEnd[2], arrEnd[3], arrEnd[4], arrEnd[5]);
    let toDateTime = ConvertDate(ED);

    let currentTime = new Date();
    if (MULTI_TIME_ZONE) {
      currentTime = multiTimeZoneHelper(item.OffsetMinutes);
    }

    // Validation: Check if start time is not in the future
    if (SD > currentTime) {
      ErrorToast("Start time cannot be in the future!");
      return;
    }

    // Validation: Check if end time is not before start time
    if (ED <= SD) {
      ErrorToast("End time must be after start time!");
      return;
    }

    // Validation: Check if end time is not in the future
    if (ED > currentTime) {
      ErrorToast("End time cannot be in the future!");
      return;
    }

    const timeDiffMinutes = differenceInMinutes(ED, SD);
    if (timeDiffMinutes < 1) {
      ErrorToast("Playback duration must be at least 1 minute!");
      return;
    }

    let tempState = {
      startTime: temp,
      endTime: toDateTime.replace(/[ :-]/g, "_"),
      deviceId: item.ParentCameraID,
      cameraName: item.CameraName || item.cameraName,
      siteName: item.SiteName,
      dateTimeOne: SD,
      dateTimeTwo: ED,
      streamName: item.StreamName,
      isTranscoded: item.isTranscoded,
    };

    if (playback) {
      setWebRTCExportStartTime(temp);
      setWebRTCExportEndTime(toDateTime.replace(/[ :-]/g, "_"));
      let obj = {
        action: "StartPlaybackUrl",
        startTime: temp,
        endTime: toDateTime.replace(/[ :-]/g, "_"),
        deviceId: item.ParentCameraID.toString() || devId.toString(),
        alertId: "",
      };
      getstreamingurl(obj)
        .then((res) => {
          if (res.status == "Ok") {
            setVideoId(id + "8");
            setVideoUrl(res.rtspURL);
            setPopOpen(false);
            setPlaybackMode(true);
            setWebRTCExportCurrentVideoHide(false);
            setLiveMode(false);
            setStartMode(false);
            setActiveSide("start")
            setStartDateString(startString);
              setEndDateString(toDateTime);
              setDifferenceInSeconds(timeDiffMinutes * 60);
              setTotalTime(secondsToHHMMSS(timeDiffMinutes * 60));
          }
        })
        .catch((err) => console.log(err));
    } else {
      // For Single Page Route
      history.push({
        pathname: CAMERA_SINGLE_PLAYBACK,
        state: {
          startTime: temp,
          endTime: toDateTime.replace(/[ :-]/g, "_"),
          deviceId: item.ParentCameraID,
          cameraName: item.CameraName,
          siteName: item.SiteName,
          dateTimeOne: SD,
          dateTimeTwo: ED,
          streamName: item.StreamName,
          isTranscoded: item.isPlaybackTranscoded,
          item: item,
          secondsDiff: timeDiffMinutes * 60,
        },
      });
    }
  };

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  const validateVideoExportRange = (
    startD,
    endD,
    diff,
    current,
    SD,
    ED
  ) => {
    if (startD.toString() === endD.toString()) {
      ErrorToast("Invalid timings");
      return false;
    }

    if (startD > current) {
      ErrorToast(
        "Invalid timings, start date time is greater than current time."
      );
      return false;
    }

    if (endD > current) {
      ErrorToast(
        "Invalid timings, end date time is greater than current time."
      );
      return false;
    }

    if (diff > 60) {
      ErrorToast("Max limit for downloading of video is 60 mins");
      return false;
    }

    if (diff < 0) {
      ErrorToast("Invalid timings");
      return false;
    }

    if (diff === 60 && SD.slice(-2) !== ED.slice(-2)) {
      ErrorToast("Max limit for downloading of video is 60 mins");
      return false;
    }

    return true;
  };
  const secondsToHHMMSS = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const hh = String(hours).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  };
console.log("videoExport",item)
  const onExportBtn = () => {
    let timeStringMain = "";
    if (timeString === "") {
      let blankArr = blankDate.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMain = blankStr;
    } else {
      timeStringMain = timeString;
    }
    let temp = dateString + "_" + timeStringMain;
    let arr = temp.split("_");
    let startD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    let SD = formatDate(
      new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
    );

    let timeStringMainTwo = "";
    if (timeStringTwo === "") {
      let blankArr = blankDateTwo.split("_");
      for (let i = 0; i < blankArr.length; i++) {
        if (blankArr[i].length == 1) {
          blankArr[i] = "0" + blankArr[i].toString();
        }
      }
      let blankStr = blankArr.join("_");
      timeStringMainTwo = blankStr;
    } else {
      timeStringMainTwo = timeStringTwo;
    }
    let tempTwo = dateStringTwo + "_" + timeStringMainTwo;
    let arrTwo = tempTwo.split("_");
    let endD = new Date(
      arrTwo[0],
      arrTwo[1] - 1,
      arrTwo[2],
      arrTwo[3],
      arrTwo[4],
      arrTwo[5]
    );
    let ED = formatDate(
      new Date(
        arrTwo[0],
        arrTwo[1] - 1,
        arrTwo[2],
        arrTwo[3],
        arrTwo[4],
        arrTwo[5]
      )
    );
    let currentTime = new Date();
    if (MULTI_TIME_ZONE) {
      currentTime = multiTimeZoneHelper(item.OffsetMinutes);
    }

    let diff = differenceInMinutes(endD, startD);
    console.log("DIFFERENCE IN MINUTES", diff)
    let current = new Date();
    if (MULTI_TIME_ZONE) {
      current = multiTimeZoneHelper(item.OffsetMinutes);
    }
    if(startD.toString() == endD.toString()){
      ErrorToast(
        "Invalid timings"
      );
      return;
    }
    if (startD > current) {
      ErrorToast(
        "Invalid timings, start date time is greater than current time."
      );
      return;
    }

    if (endD > current) {
      ErrorToast(
        "Invalid timings, end date time is greater than current time."
      );
      return;
    }

    if (diff > 60) {
      ErrorToast("Max limit for downloading of video is 60 mins");
      return;
    } else if (diff < 0) {
      ErrorToast("Invalid timings");
      return;
    } else if (diff == 60 && SD.slice(-2) != ED.slice(-2)) {
      ErrorToast("Max limit for downloading of video is 60 mins");
      return;
    }

    if (differenceTimeTwo == 0) {
      ErrorToast("The selected time is greater from the current time!");
      return;
    }
    if (SD > currentTime && differenceTimeTwo > 0) {
      ErrorToast("The selected time is greater from the current time!");
      return;
    } else {
      // Here will need to call the API to initiate download for the video with the parameters of its start time and end time.
      let user = JSON.parse(localStorage.getItem("user"));
      let d;
      if (MULTI_TIME_ZONE) {
        d = multiTimeZoneHelper(item.OffsetMinutes);
      } else {
        d = new Date();
      }
      // let currentDate = formatDate(new Date());
      let currentDate = formatDate(d);
      let devTemp =
        item.ParentCameraID || item.associatedCameraId || item.deviceId;
      let obj = {
        VideoExportLogID: "1",
        RequestedBy: user.UserUniqueID,
        RequestedByName: user.FullName,
        ExportRequestedOn: currentDate,
        DeviceID: devTemp.toString(),
        DeviceName: item.CameraName || item.cameraName || item.deviceName,
        ExportStatus: "0",
        ExportStatusDateTime: "",
        ExportStatusLog: "",
        DownloadLink: "",
        DownloadStatus: "",
        DownloadDateTime: "",
        DeleteFlag: "0",
        ExportFromDateTime: SD,
        ExportToDateTime: ED,
      };

      //Download API Call
      // addDownload(obj)
      //   .then((res) => {
      //     if (res.Status == "success") {
      //       SuccessToast(`The download request has been raised successfully. `)
      //       setPopOpen(false);
      //     } else {
      //       showErrorToast(res.Message)
      //     }
      //   }).catch(err => console.log(err));
console.log("videoExport",item)
      //Local API Call to Download
      let cName = item.CameraName || item.cameraName || item.deviceName;
      let rName = cName.replaceAll(" ", "_");
      let tempDate;
      if (MULTI_TIME_ZONE) {
        tempDate = multiTimeZoneHelper(item.OffsetMinutes);
      } else {
        tempDate = new Date();
      }
      let fileName = `${rName}-${ConvertDateThree(tempDate)}-VideoExport.mp4`;
      let localObj = {
        privateIpAddress: item.privateIPAddress || item.privateIpAddress,
        cam_user: item.camUserName,
        password: item.camPassword,
        brandName: item.BrandName || item.brandName,
        startTime: SD,
        endTime: ED,
        channelNo: item.channelNum,
        // playbackSubType: playbackSubType,
        communicationPort: item.CommunicationPort || item.communicationPort,
        httpPort:item.httpPort,
        isonvif:item.isonvif
        // internetPort: obj.InternetProtocolPort
      };
      //Bug - 7098 Resolution
      // setDownloadingLocal(true);
      WarningToast(
        "Check your downloads folder for the exported video after some time."
      );
      setPopOpen(false);
      let waitTime = FILE_DOWNLOAD_CHECK_WAIT_TIME
      if(diff <= 15){
        waitTime = 10000; // 10 seconds
      }else if(diff > 15 && diff <= 30){
        waitTime = 30000; // 30 seconds
      }else if(diff > 30 && diff <= 45){
        waitTime = 1 * 60000; // 1 mins
      }else if(diff > 45 && diff <= 60){
        waitTime = 2 * 60000; // 2 mins
      }else{
        waitTime = FILE_DOWNLOAD_CHECK_WAIT_TIME
      }
      let {
        privateIpAddress,
        cam_user,
        password,
        brandName,
        startTime,
        endTime,
        channelNo,
        communicationPort,
        httpPort,
        isonvif
      } = localObj;
      localFileDownload(
        privateIpAddress,
        communicationPort,
        httpPort,
        cam_user,
        password,
        brandName,
        isonvif,
        fileName,
        startTime,
        endTime,
        channelNo
      )
        .then((data) => {
          //Call API to check if file is downloaded.
          setTimeout(() => {
            checkFile(fileName);
          }, waitTime);
          // checkFileDownloaded(fileName)
          //   .then((res) => {
          //     if(res.res == "Yes"){
          //       SuccessToast(fileName+ " video exported successfully")
          //     }else{
          //       ErrorToast(fileName+ " video failed to export")
          //     }
          //   })
          //   .catch(err => {
          //     ErrorToast(fileName+ " video failed to export")
          //   })
        })
        .catch((err) => console.log(err));
    }
  };

  const getAlertReqDateTime = () => {
      const [day, month, yearAndTime] = alertData.reqActualTime.split("-");
      const [year, time] = yearAndTime.split(" ");
      const isoString = `${year}-${month}-${day}T${time}+05:30`; // IST offset
      setDateString(`${year}_${month}_${day}`);
      return new Date(isoString);
  }

  const downloadDirectPlayback = () => {
    let arr = webRTCexportStartTime.split("_");
    let startD = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    let SD = formatDate(startD);
    let arrTwo = webRTCexportEndTime.split("_");
    let endD = new Date(
      arrTwo[0],
      arrTwo[1] - 1,
      arrTwo[2],
      arrTwo[3],
      arrTwo[4],
      arrTwo[5]
    );
    let ED = formatDate(endD);
    let current = new Date();
    if (MULTI_TIME_ZONE) {
      current = multiTimeZoneHelper(item.OffsetMinutes);
    }
    let diff = differenceInMinutes(endD, startD);

    if (!validateVideoExportRange(startD, endD, diff, current, SD, ED)) {
      return;
    }

    let user = JSON.parse(localStorage.getItem("user"));
    let d;
    if (MULTI_TIME_ZONE) {
      d = multiTimeZoneHelper(item.OffsetMinutes);
    } else {
      d = new Date();
    }
    let currentDate = formatDate(d);
    let obj = {
      VideoExportLogID: "1",
      RequestedBy: user.UserUniqueID,
      RequestedByName: user.FullName,
      ExportRequestedOn: currentDate,
      DeviceID: item?.ParentCameraID?.toString() || id.toString(),
      DeviceName: item?.CameraName || item?.cameraName,
      ExportStatus: "0",
      ExportStatusDateTime: "",
      ExportStatusLog: "",
      DownloadLink: "",
      DownloadStatus: "",
      DownloadDateTime: "",
      DeleteFlag: "0",
      ExportFromDateTime: SD,
      ExportToDateTime: ED,
    };

    //Download APi Call
    // addDownload(obj)
    //   .then((res) => {
    //     if (res.Status == "success") {
    //       SuccessToast(`The download request has been raised successfully. `)
    //       setPopOpen(false);
    //     }
    //   }).catch(err => console.log(err));

    //Local API Call
    let cName = item.CameraName || item.cameraName || item.deviceName;
    let rName = cName.replaceAll(" ", "_");
    let temp;
    if (MULTI_TIME_ZONE) {
      temp = multiTimeZoneHelper(item.OffsetMinutes);
    } else {
      temp = new Date();
    }
    let fileName = `${rName}-${ConvertDateThree(temp)}-VideoExport.mp4`;
    let localObj = {
      privateIpAddress: item.privateIPAddress || item.privateIpAddress,
      cam_user: item.camUserName,
      password: item.camPassword,
      brandName: item.BrandName || item.brandName,
      startTime: SD,
      endTime: ED,
      channelNo: item.channelNum,
      // playbackSubType: playbackSubType,
      communicationPort: item.CommunicationPort || item.communicationPort,
      httpPort:item.httpPort,
      isonvif:item.isonvif
      // internetPort: obj.InternetProtocolPort
    };
    //Bug - 7098 Resolution
    // setDownloadingLocal(true);
    WarningToast(
      "Check your downloads folder for the exported video after some time."
    );
    setPopOpen(false);
    let waitTimer = 10000
    let {
      privateIpAddress,
      cam_user,
      password,
      brandName,
      startTime,
      endTime,
      channelNo,
      communicationPort,
      httpPort,
      isonvif
    } = localObj;
    localFileDownload(
      privateIpAddress,
      communicationPort,
      httpPort,
      cam_user,
      password,
      brandName,
      isonvif,
      fileName,
      startTime,
      endTime,
      channelNo
    )
      .then((data) => {
        setTimeout(() => {
          checkFile(fileName);
        }, waitTimer);
        // checkFileDownloaded(fileName)
        // .then((res) => {
        //   if(res.res == "Yes"){
        //     SuccessToast(fileName+ " video exported successfully")
        //   }else{
        //     ErrorToast(fileName+ "video failed to export")
        //   }
        // })
        // .catch(err => {
        //   ErrorToast(fileName+ " video failed to export")
        // })
      })
      .catch((err) => console.log(err));
  };

  const checkFile = (fileName) => {
    checkFileDownloaded(fileName)
      .then((res) => {
        if (res.res == "Yes") {
          SuccessToast(fileName + " video exported successfully");
        } else {
          ErrorToast(fileName + " video failed to export");
        }
      })
      .catch((err) => {
        ErrorToast(fileName + " video failed to export");
      });
  };

  function capture(video, scaleFactor) {
    if (scaleFactor == null) {
      scaleFactor = 1;
    }
    let h = video.videoHeight;
    let w = video.videoWidth;
    let canvas = document.createElement("canvas");
    canvas.setAttribute("id", "canvasId");
    canvas.width = w;
    canvas.height = h;
    let ctx = canvas.getContext("2d");
    let blobd = canvas.toBlob((blob) => {
      console.log("Canvas", blob);
    });
    let url = canvas.toDataURL();
    ctx.drawImage(video, 0, 0, w, h);
    return canvas;
  }

  const downloadImage = () => {
    let canvas = document.getElementById("canvasId");
    let image = canvas.toDataURL();
    let aDownloadLink = document.createElement("a");
    aDownloadLink.download = `${
      item.CameraName || item.cameraName || item.deviceName
    }_snapshot.png`;
    aDownloadLink.href = image;
    aDownloadLink.click();
  };

  const generateSnapInChat = (e) => {
    if (e.detail != 1) {
      return;
    }
    let canvas = document.getElementById("canvasId");
    let image = canvas.toDataURL();
    let fileName = `${
      item.CameraName || item.cameraName || item.deviceName
    }_${Date.now()}_snapshot.png`;
    if (CHAT_CAM_CHANGES) {
      attachalertevidencesParent(image, fileName);
    } else {
      imageToChat(image, fileName);
    }
  };

  /**
   * Invokes the <code>capture</code> function and attaches the canvas element to the DOM.
   */
  function shoot() {
    var video = document.getElementById(videoId);
    console.log("video element", video);
    var output = document.getElementById("output");
    var canvas = capture(video, scaleFactor);
    output.innerHTML = "";
    output.append(canvas);
  }

  const GetDetailsOfPanel = (pDeviceId, pMode) => {
    GetHooterPanelDetails(pDeviceId, pMode)
      .then((res) => {
        if (res.Status == "success") {
          // client component calling
          if (res.Data.length > 0) {
            LocalHooterRequest(
              res.Data[0].IP,
              res.Data[0].Port,
              pMode,
              res.Data[0].UserName,
              res.Data[0].Password,
              res.Data[0].Brand,
              res.Data[0].BranchId
            );
          }
        }
      })
      .catch((err) => console.log(err));
  };
console.log("item123",item)
  useEffect(() => {
    if (alertDetail != null || alertDetail != undefined) {
      //Check localStorage if data is present for already started hooter.
      let arr = JSON.parse(localStorage.getItem("hooterData"));
      if (arr != undefined || arr != null) {
        let devTemp =
          item.ParentCameraID || item.associatedCameraId || item.deviceId;
        if (arr.length > 0) {
          let isHooterOn = arr.filter(
            (item) =>
              item.alertId == alertDetail.alertId && item.deviceId == devTemp
          );
          if (isHooterOn.length == 1) {
            setIsAllinOneHooterOn(true);
          }
        }
      }
    }
    //get the alert type
    getAlertType();
  }, []);

  const addToLocalStorage = (alertId, deviceId) => {
    if (alertDetail == null || alertDetail == undefined) {
      return;
    }
    let isPresent = localStorage.getItem("hooterData");
    if (isPresent) {
      //Update the existing array
      let arr = JSON.parse(localStorage.getItem("hooterData"));
      let obj = {
        alertId: alertId,
        deviceId: deviceId,
      };
      arr.push(obj);
      localStorage.setItem("hooterData", JSON.stringify(arr));
    } else {
      //Add New Data in the existing array
      let arr = [];
      let obj = {
        alertId: alertId,
        deviceId: deviceId,
      };
      arr.push(obj);
      localStorage.setItem("hooterData", JSON.stringify(arr));
    }
  };

  const removeFromLocalStorage = (alertId, deviceId) => {
    if (alertDetail == null || alertDetail == undefined) {
      return;
    }
    let isPresent = localStorage.getItem("hooterData");
    if (isPresent) {
      //Check the array and remove the alert id and deviceId related entry.
      let arr = JSON.parse(localStorage.getItem("hooterData"));
      let filteredArr = arr.filter(
        (item) => item.alertId != alertId && item.deviceId != deviceId
      );
      if (filteredArr.length == 0) {
        localStorage.removeItem("hooterData");
      } else {
        localStorage.setItem("hooterData", JSON.stringify(filteredArr));
      }
    } else {
      //Add New Data in the existing array
      let arr = [];
      let obj = {
        alertId: alertId,
        deviceId: deviceId,
      };
      arr.push(obj);
      localStorage.setItem("hooterData", JSON.stringify(arr));
    }
  };

  const HooterOnOffClickRequest = (pDeviceId, pMode) => {
    GetDetailsOfPanel(pDeviceId, pMode);
    setDisableHooterBtn(true);
    HooterOnOffClick(pDeviceId, pMode)
      .then((res) => {
        if (res.Status == "success") {
          if (pMode == "on") {
            if (!res.Message.includes("success")) {
              ErrorToast(res.Message);
            } else if (
              res.Message.includes("error") ||
              res.Message.includes("failed")
            ) {
              WarningToast(res.Message);
              setIsAllinOneHooterOn(true);
              if (alertDetail != null || alertDetail != undefined) {
                addToLocalStorage(alertDetail.alertId, pDeviceId);
              }
            } else {
              SuccessToast(res.Message);
              setIsAllinOneHooterOn(true);
              if (alertDetail != null || alertDetail != undefined) {
                addToLocalStorage(alertDetail.alertId, pDeviceId);
              }
            }
            if (CHAT_CAM_CHANGES) {
              associateAttach(
                `${
                  item.CameraName || item.cameraName || item.deviceName
                } - Hooter Started`
              );
            } else {
              if (attachEvidence != undefined) {
                attachEvidence(
                  `${
                    item.CameraName || item.cameraName || item.deviceName
                  } - Hooter Started`
                );
              }
            }
          } else {
            if (!res.Message.includes("success")) {
              ErrorToast(res.Message);
            }
            if (
              res.Message.includes("error") ||
              res.Message.includes("failed")
            ) {
              WarningToast(res.Message);
              setIsAllinOneHooterOn(false);
              if (alertDetail != null || alertDetail != undefined) {
                removeFromLocalStorage(alertDetail.alertId, pDeviceId);
              }
            } else {
              SuccessToast(res.Message);
              setIsAllinOneHooterOn(false);
              if (alertDetail != null || alertDetail != undefined) {
                removeFromLocalStorage(alertDetail.alertId, pDeviceId);
              }
            }
            if (CHAT_CAM_CHANGES) {
              associateAttach(
                `${
                  item.CameraName || item.cameraName || item.deviceName
                } - Hooter Stopped`
              );
            } else {
              if (attachEvidence != undefined) {
                attachEvidence(
                  `${
                    item.CameraName || item.cameraName || item.deviceName
                  } - Hooter Stopped`
                );
              }
            }
          }
          setDisableHooterBtn(false);
        } else {
          ErrorToast(
            `${
              item.CameraName || item.cameraName || item.deviceName
            } - Hooter Activation Failed`
          );
          setDisableHooterBtn(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setDisableHooterBtn(false);
      });
  };

  const getPanelHooterDetails = () => {};

  const associateAttach = (text) => {
    let ConversationId =
      "AlertID_" +
      alertDetail.alertId +
      "_UserID_" +
      localStorage.getItem("UserID");
    let LoggedInUser = JSON.parse(localStorage.getItem("user"));
    let myCurrentDatetime = new Date();
    let _datetime = ConvertDate(myCurrentDatetime);
    let rasaconvobj = {
      evidenceType: "comment",
      text: text,
      timestamp: _datetime,
      type: "user",
    };
    addrasaconversationindb({
      assignedTo: LoggedInUser.UserID,
      rasaConversationID: ConversationId,
      uploadType: "file",
      evidence: rasaconvobj,
      conversation: null,
      userType: "operator",
      createdOn: _datetime,
      username: LoggedInUser.FullName
    })
      .then((resp) => {
        if (resp.status === "Ok") {
          if (CHAT_CAM_CHANGES) {
            let d = associateCam.map((item) => {
              let obj;
              if (item.alertId == alertDetail.alertId) {
                obj = {
                  ...item,
                  shouldRefresh: true,
                };
              } else {
                obj = {
                  ...item,
                };
              }
              return obj;
            });
            setAssociateCam(d);
          }
        } else {
          console.error(
            "Error while saving evidence to databse ",
            resp.message
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const attachalertevidencesParent = (e, fname) => {
    let LoggedInUser = JSON.parse(localStorage.getItem("user"));
    try {
      var obj = {
        evidenceFileName: fname,
        alertId: alertDetail.alertId,
        userId: LoggedInUser.UserID,
        base64String: e,
      };
      attachalertevidences(obj).then((evidenceRes) => {
        if (evidenceRes.status === "Ok") {
          OnAttachedSuccess(evidenceRes);
        } else {
          ErrorToast(evidenceRes.message);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  console.log("alertDetail123",alertDetail)
  
  const generateZeroDay = (e) => {
    if (e.detail != 1) {
      return;
    }
    let canvas = document.getElementById("canvasId");
    let image = canvas.toDataURL();
    let fileName = `${
      item.CameraName || item.cameraName || item.deviceName
    }_${Date.now()}_snapshot.png`;
    zeroDaySnap(image, fileName)
    // if (CHAT_CAM_CHANGES) {
    //   attachalertevidencesParent(image, fileName);
    // } else {
    //   imageToChat(image, fileName);
    // }
  };
  const zeroDaySnap = (e, fname) => {
    let LoggedInUser = JSON.parse(localStorage.getItem("user"));
    const extension = fname.split('.').pop();
    try {
      var obj = {
        "AttachedDocTitle": fname,
        "AlertId": item.ParentCameraID,
        "userId": LoggedInUser.Id,
        "Base64String": e,
        "DocType":extension
      };
      setButtonDisableZeroDay(true)
      attachalertevidences(obj).then((resp) => {
        if (resp.Status === "success") {
          console.log("evidenceRes",resp)
          zeroDayFunction(resp.Data.documentUrl); 
          
        } else {
          setButtonDisableZeroDay(false)
          ErrorToast(resp.Message);
        }
      }).catch(error =>{
        setButtonDisableZeroDay(false)
        ErrorToast("Attachment Upload Failed")
        console.error(error);
      });
    } catch (error) {
      setButtonDisableZeroDay(false)
      ErrorToast("Attachment Upload Failed")
      console.error(error);
    }
  };
  const zeroDayFunction =(url) =>{
    
    try{
      var obj ={
        "DeviceId":item.ParentCameraID.toString(),
        "TakeZeroDay" : url
      };
      takeZeroDataPresent(obj).then((resp)=>{
        if (resp.Status === "success"){
          SuccessToast(resp.Message)
          setButtonDisableZeroDay(false)
        }else{
          setButtonDisableZeroDay(false)
          ErrorToast(resp.Message)
        }
      });
    }catch (error) {
      console.error(error);
    }
  }

  const OnAttachedSuccess = (evidenceRes) => {
    try {
      let ConversationId =
        "AlertID_" +
        alertDetail.alertId +
        "_UserID_" +
        localStorage.getItem("UserID");
      let LoggedInUser = JSON.parse(localStorage.getItem("user"));
      var myCurrentDatetime = new Date();
      var _datetime = ConvertDate(myCurrentDatetime);
      var rasaconvobj = {
        evidenceType: "img",
        text: evidenceRes.documentUrl,
        timestamp: _datetime,
        type: "user",
      };
      var addindbobj = {
        assignedTo: LoggedInUser.UserID,
        rasaConversationID: ConversationId,
        uploadType: "file",
        evidence: rasaconvobj,
        conversation: null,
        userType: "operator",
        createdOn: _datetime,
        username: LoggedInUser.FullName
      };
      addrasaconversationindb(addindbobj).then((resp) => {
        if (resp.Status === "Ok") {
          SuccessToast("Snapshot added to chat.");
          let d = associateCam.map((item) => {
            let obj;
            if (item.alertId == alertDetail.alertId) {
              obj = {
                ...item,
                shouldRefresh: true,
              };
            } else {
              obj = {
                ...item,
              };
            }
            return obj;
          });
          setAssociateCam(d);
        } else {
          console.error(
            "Error while saving evidence to databse ",
            resp.message
          );
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const prePostHandler = () => {
    let DeviceId = item.associatedCameraId || item.deviceId;
    let DeviceBrandId = item.cameraBrandId;

    let split1 = actualTime.split(" ");
    let split2 = split1[0].split("-");

    let newdateSplit = `${split2[2]}-${split2[1]}-${split2[0]} ${split1[1]}`;
    let alerttime = new Date(newdateSplit);

    let pretime = 60;
    let posttime = 120; //1800 sec 30min
    alerttime.setSeconds(alerttime.getSeconds() - pretime);
    let styy = alerttime.getFullYear();
    let stmm = alerttime.getMonth() + 1;
    let stdd = alerttime.getDate();
    let sth = alerttime.getHours();
    let stm = alerttime.getMinutes();
    let sts = alerttime.getSeconds();

    alerttime.setSeconds(alerttime.getSeconds() + pretime + posttime);
    let etyy = alerttime.getFullYear();
    let etmm = alerttime.getMonth() + 1;
    let etdd = alerttime.getDate();
    let eth = alerttime.getHours();
    let etm = alerttime.getMinutes();
    let ets = alerttime.getSeconds();

    if (stmm.toString().length == 1) {
      stmm = "0" + stmm.toString();
    }
    if (stdd.toString().length == 1) {
      stdd = "0" + stdd.toString();
    }
    if (sth.toString().length == 1) {
      sth = "0" + sth.toString();
    }
    if (stm.toString().length == 1) {
      stm = "0" + stm.toString();
    }
    if (sts.toString().length == 1) {
      sts = "0" + sts.toString();
    }

    if (etmm.toString().length == 1) {
      etmm = "0" + etmm.toString();
    }
    if (etdd.toString().length == 1) {
      etdd = "0" + etdd.toString();
    }
    if (eth.toString().length == 1) {
      eth = "0" + eth.toString();
    }
    if (etm.toString().length == 1) {
      etm = "0" + etm.toString();
    }
    if (ets.toString().length == 1) {
      ets = "0" + ets.toString();
    }

    let startTime;
    let endTime;
    if (DeviceBrandId == 1) {
      startTime =
        styy + "_" + stmm + "_" + stdd + "_" + sth + "_" + stm + "_" + "00";
      endTime =
        etyy + "_" + etmm + "_" + etdd + "_" + eth + "_" + etm + "_" + "00";
    } else if (DeviceBrandId == 2) {
      startTime =
        styy + "_" + stmm + "_" + stdd + "_" + sth + "_" + stm + "_" + "00";
      endTime =
        etyy + "_" + etmm + "_" + etdd + "_" + eth + "_" + etm + "_" + "00";
    } else {
      startTime =
        styy + "_" + stmm + "_" + stdd + "_" + sth + "_" + stm + "_" + "00";
      endTime =
        etyy + "_" + etmm + "_" + etdd + "_" + eth + "_" + etm + "_" + "00";
    }
    setWebRTCExportStartTime(startTime);
    setWebRTCExportEndTime(endTime);
    let obj = {
      action: "StartPlaybackUrl",
      startTime: startTime,
      endTime: endTime,
      deviceId: DeviceId.toString(),
      alertId: alertDetail.alertId,
    };
    getstreamingurl(obj).then((res) => {
      if (res.status == "Ok") {
        setVideoId(id + "5");
        setVideoUrl(res.rtspURL);
        setLiveMode(false);
        setStartMode(false);
        setWebRTCExportCurrentVideoHide(false);
        if (CHAT_CAM_CHANGES) {
          let text = `${
            item.CameraName || item.cameraName || item.deviceName
          } -  PrePost Playback played.`;
          associateAttach(text);
        }
      }
    });
  };


  function TwoWayAudioClick(audio, chat, isCloseBtn) {
    var resp = "";
    var resp1 = "";
      console.log("CHAT2388",chat)
    let tempPrivateIpAddress = chat.privateIpAddress || chat.privateIPAddress;
    let tempCommunicationPort =
      chat.communicationPort || chat.CommunicationPort;
    let tempUserName = chat.camUserName || chat.camUserName;
    let tempPassword = chat.camPassword || chat.camPassword;
    let tempBrandName = chat.brandName || chat.BrandName;
    let tempCamport = chat.camPort || chat.camPort;
    let tempisonvif = chat.isonvif

    if (audio && audio == "start") {
      setIsSoundOn(false);  // Toggle two-way button state to "Stop"
      if (chat?.isonvif) {
        setIsMuted(false);  // Automatically unmute audio when two-way starts (ONVIF only)
      }
      resp1 = TwoWayCommunicationReq(0, 0, "stop", 0, 0, 0,0,0);
      resp = TwoWayCommunicationReq(
        tempPrivateIpAddress,
        tempCommunicationPort,
        "start",
        tempUserName,
        tempPassword,
        tempBrandName,
        tempCamport,
        tempisonvif
      );
      if (CHAT_CAM_CHANGES) {
        associateAttach(
          `${
            item.CameraName || item.cameraName || item.deviceName
          } - Twoway Started`
        );
      } else {
        if (attachEvidence != undefined) {
          attachEvidence(
            `${
              item.CameraName || item.cameraName || item.deviceName
            } - Twoway Started`
          );
        }
      }
    }
    if (audio && audio == "stop") {
      setIsSoundOn(true);  // Toggle two-way button state back to "Start"
      if (chat?.isonvif) {
        setIsMuted(true);  // Automatically mute audio when two-way stops (ONVIF only)
      }
      resp = TwoWayCommunicationReq(
        tempPrivateIpAddress,
        tempCommunicationPort,
        "stop",
        tempUserName,
        tempPassword,
        tempBrandName,
        tempCamport,
        tempisonvif
      );
      if (CHAT_CAM_CHANGES) {
        associateAttach(
          `${
            item.CameraName || item.cameraName || item.deviceName
          } - Twoway Stopped`
        );
      } else {
        if (attachEvidence != undefined) {
          attachEvidence(
            `${
              item.CameraName || item.cameraName || item.deviceName
            } - Twoway Stopped`
          );
        }
      }
    }
  }
  console.log("itemTwoWay",item)

  const TwoWayCommunicationReq = async (
    privateIPAddress,
    CommunicationPort,
    action,
    user,
    password,
    BrandName,
    camPort,
    isonvif
  ) => {
    try {
      if (privateIPAddress && CommunicationPort && user && password) {
        TwoWayCommunicationRequest(
          privateIPAddress,
          CommunicationPort,
          action,
          user,
          password,
          BrandName,
          camPort,
          isonvif
        ).then((resp) => {
          return resp;
        });
      } else {
        TwoWayCommunicationRequest(
          privateIPAddress,
          CommunicationPort,
          action,
          user,
          password,
          BrandName,
          camPort,
          isonvif
        ).then((resp) => {
          return resp;
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reConnection = () => {
    webSocketServerConnect();
  };

  const reConnectionTwo = (id) => {
    webSocketServerConnectTwo(id);
  };

  const handleRefreshConnection = () => {
    try {
      console.log('🔄 Refreshing WebRTC connection...');
      
      // Step 1: Close existing WebSocket connection and wait for it
      if (webSocketState) {
        webSocketState.onclose = null; // Remove existing close handler to prevent auto-reconnect
        webSocketState.close();
        console.log('🔌 WebSocket closing...');
      }
      
      // Step 2: Close existing peer connection
      if (peer_connection) {
        peer_connection.close();
        peer_connection = null;
        console.log('🔌 Peer connection closed');
      }
      
      // Step 3: Close any existing ws_conn reference
      if (ws_conn) {
        ws_conn.onclose = null;
        ws_conn.close();
        ws_conn = null;
        console.log('🔌 ws_conn closed');
      }
      
      // Step 4: Reset video element
      resetVideo();
      
      // Step 5: Reset connection attempts counter
      connect_attempts = 0;
      
      // Step 6: Clear WebSocket state
      setWebSocketState(null);
      
      // Step 7: Set loading state
      setLoading(true);
      setStreamFound(true);
      
      // Step 8: Re-establish connection after sufficient delay for cleanup
      setTimeout(() => {
        console.log('🔄 Reconnecting...');
        if (playbackMode) {
          // For playback mode, use reConnectionTwo with new random ID
          let randomNum = Math.floor(Math.random() * 100);
          reConnectionTwo(videoId + '' + randomNum);
        } else {
          // For live mode, use regular reConnection
          reConnection();
        }
        console.log('✅ Connection refresh initiated');
      }, 500); // Increased delay to 500ms for better cleanup
      
    } catch (error) {
      console.error('❌ Error refreshing connection:', error);
    }
  };

  const progressHandler = (e) => {
    if (e.playedSeconds != undefined) {
      setRunningTime(secondsToHHMMSS(e.playedSeconds));
      setTimer(e.playedSeconds);
    }
  };

  const handleSeekMouseDown = (e) => {
    // setSeeking(true);
  };

  const handleSeekMouseUp = (e) => {};

  const handleSeekChange = (e) => {
    // let temp = parseFloat(e.target.value);
    // clearTimeout(timerInt)
    // const newTimer = setTimeout(() => {
    //   setTimer(temp)
    //   // setTimer(parseFloat(e.target.value))
    //   // webSocketState.send("seek " + parseFloat(e.target.value))
    //   webSocketState.send("seek " + temp)
    // }, 500)
    // setTimerInt(newTimer)

    // setPlayed(parseFloat(e.target.value));
    const timeValue = parseFloat(e.target.value);
    setRunningTime(secondsToHHMMSS(timeValue));
    setTimer(timeValue);
    setPlayed(timeValue);
  };

  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
  }

  const showSuccessToast = (msg) => {
    toast.success(msg, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const showErrorToast = (msg) => {
    toast.error(msg, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const getAlertCodeId = (selectedAlertTypeValue) => {
    const found = alertTypeList.find(
      (type) => String(type.value) === String(selectedAlertTypeValue)
    );
    return found ? found.AlertCodeId : null;
  };

  const alertCreationfromMosaic = (item, selectedAlertType) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const OrganizationMasterID = user.OrganizationMasterID;
    
    const { TimeZoneId, BranchID,  } = item;
    
    setDisableAlertCreation(true);
    setAlertComments("")
    setSelectedAlertType("default");
    // let userDetails = JSON.parse(localStorage.getItem("user"));
    // let UserUniqueID = userDetails.UserUniqueID;
    let alertSeverity = "Moderate";
    //let alertCodeId = 0;
    //let alertType = "Manual Alert";
   // let alertTime = getCurrentDateTime();
    let alertSource = "Web";

    var video = document.getElementById(videoId);
    // var output = document.getElementById("output");
    var canvas = capture(video, scaleFactor);
    // let canvas = document.getElementById("canvasId");
    let image = canvas.toDataURL();
    console.log('IMAGE DATA URL',image)

    const payload = {
        "DeviceID": createAlertForId,
        "AlertCode": selectedAlertType,
        "AlertCodeID": getAlertCodeId(selectedAlertType),
        "AlertSource": "Web",
        "AlertImageUrl": '',
        "Base64String": image,
        "OrganizationMasterID": OrganizationMasterID,
        "TimeZoneID": TimeZoneId,
        "Branch": BranchID ? BranchID.toString() : '',
        "UserId": localStorage.getItem("UserID"),
        "AlertComments":alertComments,
    }
    // let systemDeviceid = "";
    // let aleralertPlaybackTimeTime = getCurrentDateTime();
    // console.log(`payload :|||||||||||||||||||||||||`, payload);
    alertCreation(payload)
      .then((resp) => {
        if (resp && resp.Status && resp.Status == "success") {
          showSuccessToast(
            `Alert Id - ${resp.Data.AlertId} created successfully`
          );
          setDisableAlertCreation(false);
          setAlertCreationModal(false);
     
          return resp;
        } else {
          showErrorToast(resp.Message);
          setDisableAlertCreation(false);
          return resp;
        }
      })
      .catch((err) => {
        setDisableAlertCreation(false);
        showErrorToast(err);
      });
  };
  console.log("item2578",item)
  const handleCallHome = async () => {
    try {
      const response = await callingHomePosition(
        item.privateIPAddress,
        item.camUserName,
        item.camPassword
      );
      if (response?.Status === "success") {
        SuccessToast(response.Message);
      } else {
        ErrorToast(response?.Message);
      }
    } catch (error) {
      console.error("Error calling home position:", error);
      ErrorToast("Error calling home position");
    }
  };

  //#endregion functions end

  return (
    <>
      {isSelected ? (
        <div className="alertInprogressDiv">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <img src={AlertInProgressImage} height={120} />
            <div className="alertInprogressDetail">
              <p>In progress</p>
              <p className="mb-0">
                Alert ID: <span>{alertData.alertId}</span>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>
          {streamFound ? (
            <div
              ref={videoContainerParentRef}
              className={upperDivCss}
              style={{ position: "relative" }}
            >
              {loading ? (
                displayInfo ? (
                  <>
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        backgroundColor: "#000000",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      // className={videoCss}
                      className="hoverDetails"
                    >
                      {/* <p>Loading Stream...</p> */}
                      <div class="loader">
                        <h6>
                          Loading<span class="bullets">.</span>
                        </h6>
                      </div>
                      <div
                        className={buttonCss}
                        style={{ width: "100%", justifyContent: "flex-end" }}
                      >
                        {CLOSE_CHATFLOW_BTN ? (
                          // <button
                          //   style={{ marginRight: "1rem" }}
                          //   className="SelectionAlertViewButton"
                          //   onClick={() => closedAlertBtn(alertData.alertId)}
                          // >
                          //   <p>Close Alert</p>
                          // </button>
                          <Tooltip title="Close Alert" placement="top">
                            <button className="MosaicButtonDiv" onClick={() => closedAlertBtn(alertData.alertId)}>
                              <HighlightOffRoundedIcon style={{ fill: "#ffffff", height: "24px" }} />
                            </button>
                          </Tooltip>
                        ) : null}
                        {/* <button
                          className="SelectionAlertViewButton"
                          onClick={() => chatFlowClicked(alertData.alertId)}
                        >
                          <p>Chatflow</p>
                        </button> */}
                         <Tooltip title="Chatflow" placement="top">
                            <button  className="MosaicButtonDiv" onClick={() => chatFlowClicked(alertData.alertId)}>
                              <ChatIcon style={{ fill: "#ffffff", height: "22px" }} />
                            </button>
                          </Tooltip>
                      </div>
                    </div>
                    <>
                      <div className={alertCameraHeadingCss}>
                        <div>
                          <img src={AlertIDIcon} className="mb-1" />
                          <span className="AlertCameraDetailsText ml-1">
                            {alertData.alertId}
                          </span>
                        </div>
                        <div>
                          <img src={AlertSiteIcon} className="mb-1" />
                          <span className="AlertCameraDetailsText ml-1">
                            {alertData.siteName}
                          </span>
                        </div>
                        <div>
                          { alertData.generatedByName !== null && alertData.generatedByName !== "NA" ?
                              <PersonIcon style={{width: '16px',fill:"#fafafa",marginTop:"-8px"}}/>
                          : null }
                          {/* <img src={AlertTypeIcon} className="mb-1" /> */}
                          <span className="AlertCameraDetailsText ml-1">
                            {alertData.alertType}
                          </span>
                        </div>
                        <div
                          onClick={() => setInfoOpen(true)}
                          className="infoBlueIcon"
                        >
                          <img
                            src={InformationWhite}
                            style={{ height: "12px" }}
                          />
                        </div>
                      </div>
                       {open && (
                           <>
                           <div className="closeAlertOptionOpenDiv">
                            <div className="closeAlertOptionHeight">
                              
                              {closeureAlertReasons.map((label, i) => (
                                <div
                                  key={i}
                                  onClick={() => handleSelect(label)}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    background: selected === label ? "#434343" : "transparent",
                                    fontWeight: selected === label ? "bold" : "normal",
                                  }}
                                >
                                  {selected === label && (
                                    <ListItemIcon sx={{ minWidth: "25px" }}>
                                      <CheckIcon fontSize="small" color="success" />
                                    </ListItemIcon>
                                  )}
                                  <ListItemText primary={label} className="ListTextCloseAlertOptions" />
                                </div>
                              ))}
                              </div>

                              <div style={{ textAlign: "right"}}>
                                <button
                                  className="SelectionAlertViewButton"
                                  onClick={() => setOpen(false)}>
                                  <p>Cancel</p>
                                </button>
                                <button
                                  className="SelectionAlertViewButton ml-2"
                                  disabled={!selected}
                                  onClick={handleApply}>
                                  <p>Apply</p>
                                </button>
                              </div>
                            </div>
                            </>
                      )}
                      {infoOpen && (
                        <>
                          <div className={alertCameraDetailCss}>
                            {/* <p className="TitleGrid">ID: {alertData.alertId}</p> */}
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              Device ID:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.deviceId}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              IP Address:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.privateIPAddress}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              Customer:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.customerName}
                              </span>
                            </p>
                            <p
                              className="OperateBy ReportTableFontBold MB2"
                              style={{ color: "#fff" }}
                            >
                              Device:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.deviceName}
                              </span>
                            </p>
                            <p
                              className="OperateBy ReportTableFontBold MB2"
                              style={{ color: "#fff" }}
                            >
                              Branch Id:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.branchId}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              Generated By:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.generatedByName != null
                                  ? alertData.generatedByName
                                  : "NA"}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              ACK By:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.ackbyName != null
                                  ? alertData.ackbyName
                                  : "NA"}
                              </span>
                            </p>
                            <p
                              className="OperateBy ReportTableFontBold MB2"
                              style={{ color: "#fff" }}
                            >
                              Date & Time:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.reqActualTime} (
                                {alertData.abbreviation})
                              </span>
                            </p>
                            <p
                              className="OperateBy MB5"
                              style={{ color: "#fff" }}
                            >
                              Status:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.status}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB5"
                              style={{ color: "#fff" }}
                            >
                              Address:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.address}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB5"
                              style={{ color: "#fff" }}
                            >
                              Emergency Contact:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.emergencyContact}
                              </span>
                            </p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              right: "-2px",
                              top: "33px",
                              zIndex:"999"
                            }}
                            onClick={() => setInfoOpen(false)}
                          >
                            <img src={CloseIcon} />
                          </div>
                        </>
                      )}
                    </>
                  </>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#000000",
                      color: "white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    className={videoCss}
                  >
                    {/* <p>Loading Video...</p> */}
                    <div class="loader">
                      <h6>
                        Loading<span class="bullets">.</span>
                      </h6>
                    </div>
                  </div>
                )
              ) : (
                <>
                  <div
                    className="hoverDetails"
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <video
                      id={videoId}
                      className={
                        stretchVideo
                          ? "NonStretchVideo StretchVideo"
                          : isFullscreenClick
                          ? fullVideoCss
                          : `NonStretchVideo ${videoCss}`
                      }
                      // style={{
                      //   width: "100%",
                      //   backgroundColor: "#000000",
                      //   height: "100%",
                      //   // aspectRatio: "unset"
                      //   // margin: "0px 1px 0px 1px",
                      //   // position: "relative",
                      // }}
                      // className={isFullscreenClick ? fullVideoCss : videoCss}
                      ref={videoContainerRef}
                      autoPlay={true}
                      onProgress={(e) => progressHandler(e)}
                      style={{
                        transform: `scale(${videoScale})`,
                        transformOrigin: `${zoomCenter.x}% ${zoomCenter.y}%`,
                        cursor: "default",
                      }}
                    ></video>

                    {/* {playback ? ( */}
                      <div class="overlayText">
                        {
                          liveMode ? (
                              <Tooltip title="Refresh Connection" placement="bottom">
                                <button className="RefreshBtn" onClick={handleRefreshConnection}><RefreshIcon /></button>
                              </Tooltip>
                          )
                           : null
                        }
                     
                        {liveMode ? (
                          <p id="topText" style={displayInfo ? {  } : null}>Live</p>
                        ) : (
                          <p id="topTextRed">Rec</p>
                        )}
                      </div>
                    {/* ) : null}  */}

                        {/* <div className="overlayText">
                          {
                            liveMode ? (
                              <Tooltip title="Refresh Connection" placement="bottom">
                                <button className="RefreshBtnIndicator" onClick={handleRefreshConnection}><RefreshIcon style={{fill:"#fff"}} /></button>
                              </Tooltip>
                            )
                              : null
                          }

                          
                          {liveMode ? (
                            <RecLiveIndicator type="live" />
                          ) : (
                            <RecLiveIndicator type="rec" />
                          )}
                        </div> */}



                      <div className={buttonCss} style={{ width: "100%", alignItems: "center" }}>
                        {
                        isSinglePlayback && playbackMode ?
                        (
                          null
                        )
                        :playback || showName ? (
                          <div
                          style={ { position: "relative",width:'100px' }}
                            className={` ${
                              false == "parent5x5"
                                ? "parent5x5CameraName"
                                : "MosaicCameraName"
                            }`}
                          >
                            <p>
                              {item.CameraName ||
                                item.cameraName ||
                                item.deviceName}
                            </p>
                          </div>
                        ) : null}

                    
                    
                        {!isPtzClick ? (
                          <div className="mosaicbuttons">
                            {displayInfo && (
                          <>
                            {CLOSE_CHATFLOW_BTN ? (
                              // <button
                              //   style={{ marginRight: "0.3rem", width:"9rem" }}
                              //   className="SelectionAlertViewButton"
                              //   onClick={() => closedAlertBtn(alertData.alertId)}
                              // >
                              //   <p>Close Alert</p>
                              // </button>

                              <Tooltip title="Close Alert" placement="top">
                                <button className="MosaicButtonDiv" onClick={() => closedAlertBtn(alertData.alertId)}>
                                  <HighlightOffRoundedIcon style={{ fill: "#ffffff", height: "24px" }} />
                                </button>
                              </Tooltip>
                            ) : null}
                            {/* <button style={{width:"6rem"}}
                              className="SelectionAlertViewButton"
                              onClick={() => chatFlowClicked(alertData.alertId)}
                            >
                              <p>Chatflow</p>
                            </button> */}
                            <Tooltip title="Chatflow" placement="top">
                                <button className="MosaicButtonDiv" onClick={() => chatFlowClicked(alertData.alertId)}>
                                  <ChatIcon style={{ fill: "#ffffff", height: "22px" }} />
                                </button>
                              </Tooltip>
                          </>
                        )  }
                            {(prePostDisplay || liveButton) &&
                            (!liveMode || playbackMode) ? (
                               <Tooltip title="Go Back To Live" placement="top">
                              <button
                                className="MosaicButtonDiv"
                              >
                                <img
                                  style={{ padding: "2px", height: "24px" }}
                                  src={BackToLive}
                                  alt="BacktoLive"
                                  onClick={goBackToLive}
                                />
                              </button>
                              </Tooltip>
                            ) : null}
                            {isSinglePlayback && playbackMode ? (
                              <div style={{ display: "flex", flex: 1 }}>
                                {!isPaused ? (
                                  <Tooltip title="Pause" placement="top">
                                  <button
                                    className="MosaicButtonDiv"
                                    onClick={pauseVideo}
                                  >
                                    <img
                                      style={{ padding: "2px" }}
                                      src={Pause}
                                      alt="Pause"
                                    />
                                  </button>
                                  </Tooltip>
                                ) : (
                                   <Tooltip title="Play" placement="top">
                                  <button
                                    className="MosaicButtonDiv"
                                    onClick={playVideo}
                                  >
                                    <img
                                      style={{ padding: "2px" }}
                                      src={Play}
                                      alt="Play"
                                    />
                                  </button>
                                  </Tooltip>
                                )}

                                  {displayInfo && !screenfull.isFullscreen ? null :
                                    (
                                      item.BrandName != "Hikvision" &&
                                        item.BrandName != "Raysharp" &&
                                        item?.BrandName != "Hikvision-Hybrid" ? (
                                        <Tooltip title="Restart" placement="top">
                                          <button
                                            className="MosaicButtonDiv"
                                            onClick={restartVideo}
                                          >
                                            <img
                                              style={{
                                                padding: "2px",
                                                marginLeft: "0px",
                                              }}
                                              src={Rewind}
                                              alt="Rewind"
                                            />
                                          </button>
                                        </Tooltip>
                                      ) : null
                                    )
                                  }

                                  {displayInfo && !screenfull.isFullscreen ? null :
                                    (
                                      <div
                                        style={{
                                          display: "flex",
                                          flex: 1,
                                          flexDirection: "column",
                                          margin: "0px 10px",
                                        }}
                                      >
                                        {/* {item.BrandName != "Hikvision" &&
                                          item.BrandName != "Raysharp" &&
                                          item?.BrandName != "Hikvision-Hybrid" ? ( */}
                                          <div>
                                            <div className="controls_seconds">
                                              {true ? (
                                                <span>
                                                  {runningTime} / {totalTime}
                                                </span>
                                              ) : (
                                                <span></span>
                                              )}
                                            </div>
                                            <input
                                              type="range"
                                              className="controls_seekbar"
                                              min={0}
                                              //max={secondsDiff}
                                              max={differenceInSeconds}
                                              value={timer}
                                              onMouseDown={handleSeekMouseDown}
                                              onChange={handleSeekChange}
                                              onMouseUp={handleSeekMouseUp}
                                            />
                                            <span id="sliderTitle"></span>
                                          </div>
                                         {/* ) : null} */}
                                      </div>
                                    )
                        }
                               
                              </div>
                            ) : null}

                            {showStartTimeStampBtn &&
                              item.QCStartDate == null && (
                                <Tooltip title="QC Start Time" placement="top">
                                <button
                                  className="MosaicButtonDiv"
                                  onClick={() => startTimeDevice(item)}
                                >
                                  <AccessTimeIcon
                                    style={{
                                      fill: "#ffffff",
                                      height: "24px",
                                      paddingLeft: "2px",
                                    }}
                                  />
                                </button>
                                </Tooltip>
                              )}

                            {showAuthorizeBtn && item.QCStartDate != null && (
                              <Tooltip title="Go Live" placement="top">
                              <button
                                className="MosaicButtonDiv"
                              >
                                <img
                                  style={{ padding: "2px", height: "24px" }}
                                  src={QCWhite}
                                  alt="Approved"
                                  onClick={() => authorizeDevice(item)}
                                  // onClick={() => setSnapModal(true)}
                                />
                              </button>
                              </Tooltip>
                            )}

                            {prePostDisplay && (liveMode || playbackMode) ? (
                              <Tooltip title="Pre-Post Playback" placement="top">
                              <button
                                className="MosaicButtonDiv"
                              >
                                <img
                                  style={{ padding: "2px", height: "24px" }}
                                  src={PrePost}
                                  alt="PrePost"
                                  onClick={prePostHandler}
                                />
                              </button>
                              </Tooltip>
                            ) : null}
                             {item?.IsPTZ == "1" ? (
                            <Tooltip title="PTZ Configuration" placement="top">                              
                              <button
                                className="MosaicButtonDiv"
                                onClick={() => handlePTZPresetConfiguration(item)}
                              >
                                {/* <img
                                  style={{ padding: "2px", marginLeft: "0px" }}
                                  src={PtzIcon}
                                  alt="PTZIcon"
                                /> */}
                                <SettingsApplicationsRoundedIcon style={{ fill: "#ffffff" }} />
                              </button>
                              </Tooltip>
                              ) : null}

                            {item?.IsPTZ == "1" ? (
                              // true ?
                              <Tooltip title="PTZ" placement="top">                              
                              <button
                                className="MosaicButtonDiv"
                                onClick={() => setIsPtzClick(true)}
                              >
                                <img
                                  style={{ padding: "2px", marginLeft: "0px" }}
                                  src={PtzIcon}
                                  alt="PTZIcon"
                                />
                              </button>
                              </Tooltip>
                            ) : null}

                            <Tooltip title={isMuted ? "Audio Unmute" : "Audio Mute"} placement="top">
                              <button
                                className="MosaicButtonDiv"
                                onClick={toggleMute}
                                aria-pressed={isMuted}
                              >
                                {isMuted ? (
                                  <VolumeOffRoundedIcon  style={{ fill: "#ffffff" }} />
                                ) : (
                                  <VolumeUpRoundedIcon style={{ fill: "#ffffff" }} />
                                )}
                              </button>
                            </Tooltip>
                              
                            {showPlaybackBtn && isPlaybackFuncAllowed ? (
                              <Tooltip title="Playback" placement="top">
                              <button
                                className="MosaicButtonDiv"
                                onClick={(e) => {
                                
                                  setPopOpen(true);
                                  let tempDate;
                                  if (MULTI_TIME_ZONE) {
                                    let offsetMinutes =
                                      item.OffsetMinutes || 330;
                                    tempDate =
                                      multiTimeZoneHelper(offsetMinutes);
                                  } else {
                                    tempDate = new Date();
                                  }
                                  let d = subMinutes(tempDate, 15);
                                  let temp = ConvertDate(d);
                                  let temp_date = temp
                                    .slice(0, 10)
                                    .replace(/-/g, "_");
                                  setDateString(temp_date);
                                  
                                  // Set end date to 30 minutes after start date
                                  let endDate = addMinutes(d, 15);
                                  let tempEnd = ConvertDate(endDate);
                                  let temp_date_end = tempEnd
                                    .slice(0, 10)
                                    .replace(/-/g, "_");
                                  setDateStringTwo(temp_date_end);
                                  
                                  if(displayInfo){
                                    const alertDate = getAlertReqDateTime();
                                    console.log("alertData.reqActualTime", alertDate)
                                    setDate(alertDate);
                                    setdateTwo(addMinutes(alertDate, 15));
                                  }else{
                                    console.log("tempDate", tempDate)
                                    setDate(subMinutes(tempDate, 15));
                                    setdateTwo(addMinutes(subMinutes(tempDate, 15), 15));
                                  }
                                  if (isFullscreenClick) {
                                    handleFullScreen();
                                  }
                                  setMode("Playback");
                                }}
                              >
                                <img
                                  src={PlayBack}
                                  className="camera-icon-height"
                                  alt="playback white icon"
                                  style={{ padding: "2px", height: "24px" }}
                                />
                              </button>
                              </Tooltip>
                            ) : null}

                            {showPrePostReplay &&
                            item?.brandName != "Hikvision" &&
                            item?.brandName != "Raysharp" &&
                            item?.brandName != "Hikvision-Hybrid" ? (
                              <Tooltip title="Restart" placement="top">
                              <button
                                className="MosaicButtonDiv"
                                onClick={restartPrePost}
                              >
                                <img
                                  style={{ padding: "2px", marginLeft: "0px" }}
                                  src={Rewind}
                                  alt="Rewing"
                                />
                              </button>
                              </Tooltip>
                            ) : null}

                            <Tooltip title="Snapshot" placement="top">
                            <button
                              className="MosaicButtonDiv"
                            >
                              <img
                                style={{ padding: "2px", height: "24px" }}
                                src={MosaicSnapshot}
                                alt="Snapshot"
                                onClick={() => setSnapModal(true)}
                              />
                            </button>
                            </Tooltip>
                            {showHooterIcon && liveMode ? (
                              item.ShowTwoWay && !hideTwoWay ? (
                                isSoundOn ? (
                                  <Tooltip title="Twoway Start" placement="top">
                                  <button
                                    className="MosaicButtonDiv"
                                  >
                                    <img
                                      style={{ padding: "2px" }}
                                      src={MosaicTwowayStart}
                                      alt="TwowayStart"
                                      onClick={() =>
                                        TwoWayAudioClick("start", item)
                                      }
                                    />
                                  </button>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Twoway Stop" placement="top">
                                  <button
                                    className="MosaicButtonDiv"
                                  >
                                    <img
                                      style={{ padding: "2px" }}
                                      src={MosaicTwowayStop}
                                      alt="TwowayStop"
                                      onClick={() =>
                                        TwoWayAudioClick("stop", item)
                                      }
                                    />
                                  </button>
                                  </Tooltip>
                                )
                              ) : null
                            ) : null}
                            {showHooterIcon && liveMode ? (
                              item.ShowHooter ? (
                                !isAllinOneHooterOn ? (
                                  <Tooltip title="Hooter On" placement="top">
                                  <button
                                    disabled={disableHooterBtn}
                                    className="MosaicButtonDiv"
                                  >
                                    <img
                                      style={{ padding: "2px" }}
                                      src={MosaicHooterOn}
                                      alt="HooterOn"
                                      onClick={(e) => {
                                        if (e.detail != 1) {
                                          return;
                                        }
                                        HooterOnOffClickRequest(
                                          item.ParentCameraID ||
                                            item.associatedCameraId ||
                                            item.deviceId,
                                          "on"
                                        );
                                      }}
                                    />
                                  </button>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Hooter Off" placement="top">
                                  <button
                                    disabled={disableHooterBtn}
                                    className="MosaicButtonDivoff"
                                  >
                                    <img
                                      style={{ padding: "2px" }}
                                      src={MosaicHooterOff}
                                      alt="HooterOff"
                                      onClick={(e) => {
                                        if (e.detail != 1) {
                                          return;
                                        }
                                        HooterOnOffClickRequest(
                                          item.ParentCameraID ||
                                            item.associatedCameraId ||
                                            item.deviceId,
                                          "off"
                                        );
                                      }}
                                    />
                                  </button>
                                  </Tooltip>
                                )
                              ) : null
                            ) : null}

                          <Tooltip title={
                                isFullscreenClick
                                  ? "Exit Full Screen"
                                  : "Full Screen"
                              } placement="top">
                            <button
                              className="MosaicButtonDiv"
                              onClick={handleFullScreen}
                            >
                              {!isFullscreenClick ? (
                                <img
                                  style={{ padding: "2px" }}
                                  src={MosaicFullscreen}
                                  alt="Full"
                                />
                              ) : (
                                <img
                                  style={{ padding: "2px" }}
                                  src={MosaicExitFullscreen}
                                  alt="Exit"
                                />
                              )}
                            </button>
                          </Tooltip>
                            {!HIDE_STUFF && isExportFuncAllowed ? (
                              <Tooltip title="Video Export" placement="top">
                              <button
                                className="MosaicButtonDiv"
                              >
                                <img
                                  style={{ padding: "2px", height: "24px" }}
                                  src={Video_Export}
                                  alt="video Export Button"
                                  onClick={() => {
                                    setPopOpen(true);
                                    let d;
                                    if (MULTI_TIME_ZONE) {
                                      let offsetMinutes =
                                        item.OffsetMinutes || 330;
                                      d = multiTimeZoneHelper(offsetMinutes);
                                    } else {
                                      d = new Date();
                                    }
                                    setDate(subMinutes(d, 60));
                                    setdateTwo(d);
                                    setTimeString("");
                                    setTimeStringTwo("");
                                    if (isFullscreenClick) {
                                      handleFullScreen();
                                    }
                                    setMode("Export");
                                  }}
                                />
                              </button>
                              </Tooltip>
                            ) : null}
                            {showAlertCreation && liveMode ? (
                              <Tooltip title="Alert Creation" placement="top">
                              <button className="MosaicButtonDiv"
                                onClick={(e) => {
                                  setCreateAlertForId(item.ParentCameraID);
                                  setAlertCreationModal(true);
                                   if (isFullscreenClick) {
                                      handleFullScreen();
                                    }
                                }}
                                disabled={disableAlertCreation}>
                                <img
                                  style={{ padding: "2px" }}
                                  src={AlertOption1}
                                  alt="Alert Creation Button"
                                />
                              </button>
                              </Tooltip>
                            ) : null}
                          </div>
                        ) : (
                          <div
                            className="mosaicbuttons"
                            style={{ justifyContent: "space-between" }}
                          >
                            <Tooltip title="Back Arrow" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              style={{ borderRadius: "unset" }}
                              onClick={() => setIsPtzClick(false)}
                            >
                              <img
                                style={{ padding: "2px", marginLeft: "0px" }}
                                src={BackArrowDevice}
                                alt="BackArrow"
                              />
                            </button>
                            </Tooltip>

                             <Tooltip title="Home" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              style={{ borderRadius: "unset" }}
                              onClick={handleCallHome}
                            >
                              <HomeRoundedIcon style={{ padding: "2px", marginLeft: "0px", fill:"#ffffff" }} />
                            </button>
                            </Tooltip>

                            {/* <button data-title='Home' className='MosaicButtonDiv'>
                                <img style={{ padding: "2px", marginLeft: "0px" }}
                                  src={PtzHomeIcon}
                                  alt="HomeIcon"
                                />
                          </button> */}
                          <Tooltip title="Left" placement="top">
                            <button
                              //disabled={ptzControlLoading}
                              className="MosaicButtonDiv"
                              onClick={Left}
                            >
                              <img
                                style={{ padding: "2px", marginLeft: "0px" }}
                                src={PtzLeftArrow}
                                alt="LeftArrow"
                              />
                            </button>
                            </Tooltip>
                            <Tooltip title="Right" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              onClick={Right}
                              //disabled={ptzControlLoading}
                            >
                              <img
                                style={{ padding: "2px", marginLeft: "0px" }}
                                src={PtzRightArrow}
                                alt="RightArrow"
                              />
                            </button>
                            </Tooltip>
                             <Tooltip title="Up" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              onClick={Up}
                              //disabled={ptzControlLoading}
                            >
                              <img
                                // style={{ padding: "2px", marginLeft: "0px" }}
                                src={PtzUpArrow}
                                alt="TopArrow"
                                width={18}
                              />
                            </button>
                            </Tooltip>
                             <Tooltip title="Down" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              onClick={Down}
                              //disabled={ptzControlLoading}
                            >
                              <img
                                // style={{ padding: "2px", marginLeft: "0px" }}
                                width={18}
                                src={PtzDownArrow}
                                alt="BottomArrow"
                              />
                            </button>
                            </Tooltip>
                             <Tooltip title="Zoom in" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              // onClick={ZoomIn}
                              //disabled={ptzControlLoading}
                              onClick={() => setZoom("IN")}
                            >
                              <img
                                style={{ padding: "2px", marginLeft: "0px" }}
                                src={PtzZoomInIcon}
                                alt="PlusIcon"
                              />
                            </button>
                            </Tooltip>
                            <Tooltip title="Zoom out" placement="top">
                            <button
                              className="MosaicButtonDiv"
                              // onClick={ZoomOut}
                              //disabled={ptzControlLoading}
                              onClick={() => setZoom("OUT")}
                            >
                              <img
                                style={{ padding: "2px", marginLeft: "0px" }}
                                src={PtzZoomOutIcon}
                                alt="MinusIcon"
                                width={21}
                              />
                            </button>
                            </Tooltip>
                          </div>
                        )}
                        <div>
                          <Modal
                            show={downloadingLocal}
                            backdrop="static"
                            className="loaderSpinner"
                          >
                            <Spinner
                              style={{ marginLeft: "6rem" }}
                              animation="border"
                              variant="primary"
                            />
                            <span style={{ padding: "1rem" }}>
                              Downloading file... Please wait
                            </span>
                          </Modal>
                          <Modal
                            show={popOpen}
                            onHide={() => setPopOpen(false)}
                            className={
                              webRTCExportCurrentVideoHide || mode == "Playback"
                                ? "singleplaybackexportModal"
                                : "ExportModal"
                            }
                            backdrop="static"
                          >
                            <Modal.Header closeButton>
                              {mode == "Playback" ? (
                                <Modal.Title>
                                  <p className="ModelHeaderName">
                                    {item.CameraName || item.cameraName}{" "}
                                    Playback
                                  </p>
                                </Modal.Title>
                              ) : (
                                <Modal.Title>
                                  <p className="ModelHeaderName">
                                    {item.CameraName || item.cameraName} Export
                                  </p>
                                </Modal.Title>
                              )}
                            </Modal.Header>
                            <Modal.Body>
                              <PopupCard
                                item={item}
                                dateChange={dateChangeStart}
                                date={date}
                                getDataFromChild={getDataFromChild}
                                onSubmitBtn={
                                  mode == "Playback" ? onSubmitBtn : onExportBtn
                                }
                                setBlankDate={setBlankDate}
                                timeStringMain={timeStringMain}
                                mode={mode}
                                setBlankDateTwo={setBlankDateTwo}
                                getDataFromChildTwo={getDataFromChildTwo}
                                timeStringMainTwo={timeStringMainTwo}
                                dateTwo={dateTwo}
                                activeSide={activeSide}
                                setActiveSide={setActiveSide}
                                dateChangeTwo={dateChangeEnd}
                                exportCurrentVideoHide={
                                  webRTCExportCurrentVideoHide
                                }
                                videoExportDownload={downloadDirectPlayback}
                              />
                            </Modal.Body>
                          </Modal>

                          <Modal
                            show={snapModal}
                            onHide={() => setSnapModal(false)}
                            size="lg"
                            style={{ zIndex: "99999" }}
                            backdrop="static"
                          >
                            <Modal.Header closeButton>
                              <p className="ModelHeaderName">
                                {item.cameraName} Snapshot
                              </p>
                            </Modal.Header>

                            <Modal.Body>
                              <div id="output"></div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: "0.5rem",
                                }}
                              >
                                <button
                                  className="downloadbuttonNewUI"
                                  onClick={downloadImage}
                                >
                                  Download Image
                                </button>
                                {showAuthorizeBtn && SHOW_VISUAL_COMPONENTS ? (
                                  <button
                                    disabled={buttonDisableZeroDay}
                                    className="downloadbuttonNewUI"
                                    onClick={(e) => generateZeroDay(e)}
                                  >
                                    Zero Day
                                  </button>
                                ) : null}
                                {showDirectToChat ? (
                                  <button
                                    className="downloadbuttonNewUI"
                                    disabled={buttonDisable}
                                    onClick={(e) => generateSnapInChat(e)}
                                  >
                                    Add to Chat
                                  </button>
                                ) : null}
                              </div>
                            </Modal.Body>
                          </Modal>

                          <Modal
                            show={alertCreationModal}
                            onHide={() => setAlertCreationModal(false)}
                            size="lg"
                            style={{ zIndex: "99999" }}
                            backdrop="static"
                          >
                            <Modal.Header closeButton>
                              <p className="ModelHeaderName">Alert Creation</p>
                            </Modal.Header>

                            <Modal.Body>
                              <div>
                                <div className="inputMainContainer w40dot75rem">
                                  <div className="inputTypeLabelContainer">
                                    <label className="formFieldLabels">
                                      Alert Type *
                                    </label>
                                    <select
                                      class="inputType ArrowSelectClass"
                                      value={selectedAlertType}
                                      onChange={e => setSelectedAlertType(e.target.value)}
                                    >
                                      <option key="default" value="default" id="default">
                                        Select Alert Type
                                      </option>
                                      {alertTypeList &&
                                        alertTypeList.map((type) => (
                                          <option
                                            key={type.value}
                                            value={type.value}
                                          >
                                            {type.label}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>

                                <div className="inputMainContainer w40dot75rem" style={{height: "150px"}}>
                                  <div className="inputTypeLabelContainer" style={{height: "148px"}}>
                                    <label className="formFieldLabels">Tag</label>
                                    <textarea
                                      className="form-control formField description-textbox textAreaALertCreation"
                                    style={{height: "148px"}} value={alertComments} onChange={e => setAlertComments(e.target.value)}></textarea>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <button
                                    className="DataAccessEdit"
                                    style={{ width: "150px" }}
                                    onClick={() => {
                                      alertCreationfromMosaic(item, selectedAlertType);
                                    }}
                                    disabled={selectedAlertType === null || selectedAlertType === "default"}
                                  >
                                    <span className="ViewUpdate">
                                      Generate Alert
                                    </span>
                                  </button>
                                  <button
                                    className="DataAccessEdit"
                                    style={{ width: "100px" }}
                                    onClick={() =>{
                                      setSelectedAlertType("default");
                                      setAlertCreationModal(false);
                                    } }
                                  >
                                    <span className="ViewUpdate">Cancel</span>
                                  </button>
                                </div>
                              </div>
                            </Modal.Body>
                          </Modal>

                            <Modal
                              show={PTZConfigurationModal}
                              onHide={() => setPTZConfigurationModal(false)}
                              size="lg"
                              style={{ zIndex: "99999" }}
                              backdrop="static"
                            >
                              <Modal.Header closeButton>
                                <p className="ModelHeaderName">
                                  {item.cameraName} PTZ Configuration
                                </p>
                              </Modal.Header>

                              <Modal.Body>
                                <style>{`
                                  @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                  }
                                `}</style>
                                <div>
                                  <div style={{height:"150px"}}>

                                    {/* Preset List */}
                                    <div className="inputMainContainer w40dot75rem" style={{ width: "300px" }}>
                                      <div className="inputTypeLabelContainer">
                                        <label className="formFieldLabels" style={{ marginRight: "0.5rem" }}>
                                          Preset List
                                        </label>

                                        {presetListLoading ? (
                                          <div style={{ display: "flex", alignItems: "center", marginTop: "0.5rem" }}>
                                            <div style={{
                                              width: "16px",
                                              height: "16px",
                                              border: "2px solid #f3f3f3",
                                              borderTop: "2px solid #3498db",
                                              borderRadius: "50%",
                                              animation: "spin 1s linear infinite",
                                              marginRight: "0.5rem"
                                            }} />
                                            <span style={{ color: "#999" }}>Loading presets...</span>
                                          </div>
                                        ) : presetList && presetList.length > 0 ? (
                                          <select 
                                            className="inputType ArrowSelectClass"
                                            value={selectedPreset?.Token || ""}
                                            onChange={(e) => {
                                              const token = e.target.value;
                                              const presetObj =
                                                presetList.find((p) => p.Token === token) || {};
                                              setSelectedPreset(presetObj);
                                            }}
                                          >
                                            <option value="">Select Preset Options</option>
                                            {presetList.map((preset) => (
                                              <option key={preset.Token} value={preset.Token}>
                                                {preset.Name}
                                              </option>
                                            ))}
                                          </select>
                                        ) : (
                                          <p style={{ color: "#999", marginTop: "0.5rem" }}>No Preset available</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <button
                                      className="DataAccessEdit"
                                      style={{ width: "100px" }}
                                      disabled = {!selectedPreset?.Token}
                                      onClick={()=>onPresetCallBtnClick()}>
                                      <span className="ViewUpdate">
                                        Call
                                      </span>
                                    </button>
                                    <button
                                      className="DataAccessEdit"
                                      style={{ width: "100px" }}
                                      onClick={() => {onPresetModalClose()}}
                                    >
                                      <span className="ViewUpdate">Cancel</span>
                                    </button>
                                  </div>
                                </div>
                              </Modal.Body>
                            </Modal>
                        </div>
                      </div>
                    
                  </div>
                  {displayInfo ? (
                    <>
                      <div className={alertCameraHeadingCss}>
                        <div>
                          <img src={AlertIDIcon} className="mb-1" />
                          <span className="AlertCameraDetailsText ml-1">
                            {alertData.alertId}
                          </span>
                        </div>
                        <div>
                          <img src={AlertSiteIcon} className="mb-1" />
                          <span className="AlertCameraDetailsText ml-1">
                            {alertData.siteName}
                          </span>
                        </div>
                        <div>
                           { alertData.generatedByName !== null && alertData.generatedByName !== "NA" ?
                              <PersonIcon style={{width: '16px',fill:"#fafafa", marginTop:"-8px"}}/>
                          : null }
                          {/* <img src={AlertTypeIcon} className="mb-1" /> */}
                          <span className="AlertCameraDetailsText ml-1">
                            {alertData.alertType}
                          </span>
                        </div>
                        <div className="d-flex">
                          {/* <button
                            style={{ marginRight: "1rem" }}
                            className="SelectionAlertViewButton"
                            onClick={() => closedAlertBtn(alertData.alertId)}
                          >
                            <p>Close Alert</p>
                          </button> */}
                        <div
                          onClick={() => setInfoOpen(true)}
                          className="infoBlueIcon"
                        >
                          <img
                            src={InformationWhite}
                            style={{ height: "12px" }}
                          />
                        </div>
                        </div>
                      </div>
                      {open && (
                           <>
                           <div className="closeAlertOptionOpenDiv">
                            <div className="closeAlertOptionHeight">
                              
                              {closeureAlertReasons.map((label, i) => (
                                <div
                                  key={i}
                                  onClick={() => handleSelect(label)}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    background: selected === label ? "#434343" : "transparent",
                                    fontWeight: selected === label ? "bold" : "normal",
                                  }}
                                >
                                  {selected === label && (
                                    <ListItemIcon sx={{ minWidth: "25px" }}>
                                      <CheckIcon fontSize="small" color="success" />
                                    </ListItemIcon>
                                  )}
                                  <ListItemText primary={label} className="ListTextCloseAlertOptions" />
                                </div>
                              ))}
                              </div>

                              <div style={{ textAlign: "right"}}>
                                <button
                                  className="SelectionAlertViewButton"
                                  onClick={() => setOpen(false)}>
                                  <p>Cancel</p>
                                </button>
                                <button
                                  className="SelectionAlertViewButton ml-2"
                                  disabled={!selected}
                                  onClick={handleApply}>
                                  <p>Apply</p>
                                </button>
                              </div>
                            </div>
                            </>
                      )}
                      {infoOpen && (
                        <>
                          <div className={alertCameraDetailCss}>
                            {/* <p className="TitleGrid">ID: {alertData.alertId}</p> */}
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              Device ID:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.deviceId}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              IP Address:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.privateIPAddress}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              Customer:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.customerName}
                              </span>
                            </p>
                            <p
                              className="OperateBy ReportTableFontBold MB2"
                              style={{ color: "#fff" }}
                            >
                              Device:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.deviceName}
                              </span>
                            </p>
                            <p
                              className="OperateBy ReportTableFontBold MB2"
                              style={{ color: "#fff" }}
                            >
                              Branch Id:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.branchId}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              Generated By:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.generatedByName != null
                                  ? alertData.generatedByName
                                  : "NA"}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB2"
                              style={{ color: "#fff" }}
                            >
                              ACK By:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.ackbyName != null
                                  ? alertData.ackbyName
                                  : "NA"}
                              </span>
                            </p>
                            <p
                              className="OperateBy ReportTableFontBold MB2"
                              style={{ color: "#fff" }}
                            >
                              Date & Time:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.reqActualTime} (
                                {alertData.abbreviation})
                              </span>
                            </p>
                            <p
                              className="OperateBy MB5"
                              style={{ color: "#fff" }}
                            >
                              Status:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.status}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB5"
                              style={{ color: "#fff" }}
                            >
                              Address:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.address}
                              </span>
                            </p>
                            <p
                              className="OperateBy MB5"
                              style={{ color: "#fff" }}
                            >
                              Emergency Contact:
                              <span
                                className="OperateName ml-1"
                                style={{ color: "#fff" }}
                              >
                                {alertData.emergencyContact}
                              </span>
                            </p>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              right: "-2px",
                              top: "33px",
                              zIndex:"999",
                              cursor:"pointer"
                            }}
                            onClick={() => setInfoOpen(false)}
                          >
                            <img src={CloseIcon} />
                          </div>
                        </>
                      )}
                    </>
                  ) : null}
                </>
              )}
            </div>
          ) : displayInfo ? (
            <>
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#000000",
                  color: "green",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                // className={videoCss}
                className="hoverDetails"
              >
                <p>Loading Stream...</p>
                <div
                  className={buttonCss}
                  style={{ width: "100%", justifyContent: "flex-end" }}
                >
                  {CLOSE_CHATFLOW_BTN ? (
                    // <button
                    //   style={{ marginRight: "1rem" }}
                    //   className="SelectionAlertViewButton"
                    //   onClick={() => closedAlertBtn(alertData.alertId)}
                    // >
                    //   <p>Close Alert</p>
                    // </button>
                    <Tooltip title="Close Alert" placement="top">
                      <button className="MosaicButtonDiv" onClick={() => closedAlertBtn(alertData.alertId)}>
                        <HighlightOffRoundedIcon style={{ fill: "#ffffff", height: "24px" }} />
                      </button>
                    </Tooltip>
                  ) : null}

                  {/* <button
                    className="SelectionAlertViewButton"
                    onClick={() => chatFlowClicked(alertData.alertId)}
                  >
                    <p>Chatflow</p>
                  </button> */}
                   <Tooltip title="Chatflow" placement="top">
                      <button className="MosaicButtonDiv" onClick={() => chatFlowClicked(alertData.alertId)}>
                        <ChatIcon style={{ fill: "#ffffff", height: "22px" }} />
                      </button>
                    </Tooltip>
                </div>
              </div>
              <div className={alertCameraHeadingCss}>
                <div>
                  <img src={AlertIDIcon} className="mb-1" />
                  <span className="AlertCameraDetailsText ml-1">
                    {alertData.alertId}
                  </span>
                </div>
                <div>
                  <img src={AlertSiteIcon} className="mb-1" />
                  <span className="AlertCameraDetailsText ml-1">
                    {alertData.siteName}
                  </span>
                </div>
                <div>
                  <img src={AlertTypeIcon} className="mb-1" />
                  <span className="AlertCameraDetailsText ml-1">
                    {alertData.alertType}
                  </span>
                </div>
                <div onClick={() => setInfoOpen(true)}>
                  <img src={InfoBlue} />{" "}
                </div>
              </div>
               {open && (
                    <>
                      <div className="closeAlertOptionOpenDiv">
                        <div className="closeAlertOptionHeight">

                          {closeureAlertReasons.map((label, i) => (
                            <div
                              key={i}
                              onClick={() => handleSelect(label)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                marginLeft:"10px",
                                background: selected === label ? "#434343" : "transparent",
                                fontWeight: selected === label ? "bold" : "normal",
                              }}
                            >
                              {selected === label && (
                                <ListItemIcon sx={{ minWidth: "25px" }}>
                                  <CheckIcon fontSize="small" color="success" />
                                </ListItemIcon>
                              )}
                              <ListItemText primary={label} className="ListTextCloseAlertOptions" />
                            </div>
                          ))}
                        </div>

                        <div style={{ textAlign: "right" }}>
                          <button
                            className="SelectionAlertViewButton"
                            onClick={() => setOpen(false)}>
                            <p>Cancel</p>
                          </button>
                          <button
                            className="SelectionAlertViewButton ml-2"
                            disabled={!selected}
                            onClick={handleApply}>
                            <p>Apply</p>
                          </button>
                        </div>
                      </div>
                    </>
                  )}
              {infoOpen && (
                <>
                  <div className={alertCameraDetailCss}>
                    {/* <p className="TitleGrid">ID: {alertData.alertId}</p> */}
                    <p className="OperateBy MB2" style={{ color: "#fff" }}>
                      Device ID:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.deviceId}
                      </span>
                    </p>

                    <p className="OperateBy MB2" style={{ color: "#fff" }}>
                      IP Address:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.privateIPAddress}
                      </span>
                    </p>
                    <p className="OperateBy MB2" style={{ color: "#fff" }}>
                      Customer:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.customerName}
                      </span>
                    </p>
                    <p
                      className="OperateBy ReportTableFontBold MB2"
                      style={{ color: "#fff" }}
                    >
                      Device:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.deviceName}
                      </span>
                    </p>
                    <p
                      className="OperateBy ReportTableFontBold MB2"
                      style={{ color: "#fff" }}
                    >
                      Branch Id:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.branchId}
                      </span>
                    </p>
                    <p className="OperateBy MB2" style={{ color: "#fff" }}>
                        Generated By:
                        <span
                          className="OperateName ml-1"
                          style={{ color: "#fff" }}
                        >
                          {alertData.generatedByName != null
                            ? alertData.generatedByName
                            : "NA"}
                      </span>
                    </p>
                    <p className="OperateBy MB2" style={{ color: "#fff" }}>
                      ACK By:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.ackbyName != null
                          ? alertData.ackbyName
                          : "NA"}
                      </span>
                    </p>
                    <p
                      className="OperateBy ReportTableFontBold MB2"
                      style={{ color: "#fff" }}
                    >
                      Date & Time:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.reqActualTime} ({alertData.abbreviation})
                      </span>
                    </p>
                    <p className="OperateBy MB5" style={{ color: "#fff" }}>
                      Status:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.status}
                      </span>
                    </p>
                    <p className="OperateBy MB5" style={{ color: "#fff" }}>
                      Address:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.address}
                      </span>
                    </p>
                    <p className="OperateBy MB5" style={{ color: "#fff" }}>
                      Emergency Contact:
                      <span
                        className="OperateName ml-1"
                        style={{ color: "#fff" }}
                      >
                        {alertData.emergencyContact}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{ position: "absolute", right: "-2px", top: "33px" }}
                    onClick={() => setInfoOpen(false)}
                  >
                    <img src={CloseIcon} />
                  </div>
                </>
              )}
            </>
          ) : (
            <div className={noStreamDivCss} style={{ position: "relative" }}>
              <img
                src={MosaicNoStream}
                alt="Video"
                className="w-100 image-bg mosaic-nostream-img"
              />
              <div
                className="PanelDetailDiv"
                style={{
                  position: "absolute",
                  bottom: "1%",
                  left: "1%",
                  paddingLeft: "2px",
                   cursor:"pointer"
                }}
              >
                <p>
                  <span>
                    {item.CameraName || item.cameraName || item.deviceName}
                  </span>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default WebRTCPlayer;
